var $68a780a658d1828a$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $68a780a658d1828a$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $68a780a658d1828a$exports));
try {
    regeneratorRuntime = $68a780a658d1828a$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $68a780a658d1828a$var$runtime;
    else Function("r", "regeneratorRuntime = r")($68a780a658d1828a$var$runtime);
}


var $64eaa142b8a11f76$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return n(r, t, e, a);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return n(r, t, e, a, u);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return function(i) {
                                return n(r, t, e, a, u, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return function(i) {
                                return function(c) {
                                    return n(r, t, e, a, u, i, c);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, a) {
        return 4 === n.a ? n.f(r, t, e, a) : n(r)(t)(e)(a);
    }
    function A5(n, r, t, e, a, u) {
        return 5 === n.a ? n.f(r, t, e, a, u) : n(r)(t)(e)(a)(u);
    }
    function A6(n, r, t, e, a, u, i) {
        return 6 === n.a ? n.f(r, t, e, a, u, i) : n(r)(t)(e)(a)(u)(i);
    }
    function A7(n, r, t, e, a, u, i, c) {
        return 7 === n.a ? n.f(r, t, e, a, u, i, c) : n(r)(t)(e)(a)(u)(i)(c);
    }
    function t(n, r) {
        for(var t, a = [], u = e(n, r, 0, a); u && (t = a.pop()); u = e(t.a, t.b, 0, a));
        return u;
    }
    function e(n, r, t, a) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && g(5), !1;
        if (t > 100) return a.push(c(n, r)), !0;
        for(var u in 0 > n.$ && (n = Fr(n), r = Fr(r)), n)if (!e(n[u], r[u], t + 1, a)) return !1;
        return !0;
    }
    function a(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = a(n.a, r.a)) || (t = a(n.b, r.b)) ? t : a(n.c, r.c);
        for(; n.b && r.b && !(t = a(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var u = F2(function(n, r) {
        return 0 > a(n, r);
    }), i = F2(function(n, r) {
        var t = a(n, r);
        return 0 > t ? Ar : t ? _r : kr;
    });
    function c(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function o(n) {
        return n;
    }
    function f(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    var s = F2(b);
    function b(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = v(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = v(n.a, r);
        return t;
    }
    var d = {
        $: 0
    };
    function v(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var l = F2(v);
    function h(n) {
        for(var r = d, t = n.length; t--;)r = v(n[t], r);
        return r;
    }
    function w(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var p = F3(function(n, r, t) {
        for(var e = Array(n), a = 0; n > a; a++)e[a] = t(r + a);
        return e;
    }), $ = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, c(t, r);
    });
    function g(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    var m = F2(function(n, r) {
        return n + r;
    }), y = F2(function(n, r) {
        return n - r;
    }), x = F2(function(n, r) {
        return n * r;
    }), k = F2(function(n, r) {
        var t = r % n;
        return 0 === n ? g(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), _ = Math.ceil, A = Math.floor, z = Math.round, j = Math.log, F = F2(function(n, r) {
        return n + r;
    }), L = F2(function(n, r) {
        return n + r;
    }), S = F3(function(n, r, t) {
        for(var e = t.length, a = 0; e > a;){
            var u = t[a], i = t.charCodeAt(a);
            a++, 55296 > i || i > 56319 || (u += t[a], a++), r = A2(n, o(u), r);
        }
        return r;
    }), G = F2(function(n, r) {
        return r.split(n);
    }), R = F2(function(n, r) {
        return r.join(n);
    }), T = F3(function(n, r, t) {
        return t.slice(n, r);
    }), C = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), M = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), N = F2(function(n, r) {
        var t = n.length;
        if (1 > t) return d;
        for(var e = 0, a = []; (e = r.indexOf(n, e)) > -1;)a.push(e), e += t;
        return h(a);
    });
    function E(n) {
        return n + "";
    }
    function O(n) {
        return {
            $: 2,
            b: n
        };
    }
    function I(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    O(function(n) {
        return "number" != typeof n ? U("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? Tr(n) : !isFinite(n) || n % 1 ? U("an INT", n) : Tr(n);
    }), O(function(n) {
        return "boolean" == typeof n ? Tr(n) : U("a BOOL", n);
    }), O(function(n) {
        return "number" == typeof n ? Tr(n) : U("a FLOAT", n);
    }), O(function(n) {
        return Tr(n);
    }), O(function(n) {
        return "string" == typeof n ? Tr(n) : n instanceof String ? Tr(n + "") : U("a STRING", n);
    });
    var H = F2(function(n, r) {
        return I(n, [
            r
        ]);
    }), Z = F3(function(n, r, t) {
        return I(n, [
            r,
            t
        ]);
    }), q = F2(function(n, r) {
        return P(n, r);
    });
    function P(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? Tr(n.c) : U("null", r);
            case 3:
                return D(r) ? B(n.b, r, h) : U("a LIST", r);
            case 4:
                return D(r) ? B(n.b, r, Q) : U("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return U("an OBJECT with a field named `" + t + "`", r);
                var e = P(n.b, r[t]);
                return vt(e) ? e : Lr(A2(Gr, t, e.a));
            case 7:
                var a = n.e;
                return D(r) ? r.length > a ? (e = P(n.b, r[a]), vt(e) ? e : Lr(A2(Rr, a, e.a))) : U("a LONGER array. Need index " + a + " but only see " + r.length + " entries", r) : U("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || D(r)) return U("an OBJECT", r);
                var u = d;
                for(var i in r)if (r.hasOwnProperty(i)) {
                    if (e = P(n.b, r[i]), !vt(e)) return Lr(A2(Gr, i, e.a));
                    u = v(c(i, e.a), u);
                }
                return Tr(Br(u));
            case 9:
                for(var o = n.f, f = n.g, s = 0; f.length > s; s++){
                    if (e = P(f[s], r), !vt(e)) return e;
                    o = o(e.a);
                }
                return Tr(o);
            case 10:
                return e = P(n.b, r), vt(e) ? P(n.h(e.a), r) : e;
            case 11:
                for(var b = d, l = n.g; l.b; l = l.b){
                    if (e = P(l.a, r), vt(e)) return e;
                    b = v(e.a, b);
                }
                return Lr(Cr(Br(b)));
            case 1:
                return Lr(A2(Sr, n.a, r));
            case 0:
                return Tr(n.a);
        }
    }
    function B(n, r, t) {
        for(var e = r.length, a = Array(e), u = 0; e > u; u++){
            var i = P(n, r[u]);
            if (!vt(i)) return Lr(A2(Rr, u, i.a));
            a[u] = i.a;
        }
        return Tr(t(a));
    }
    function D(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function Q(n) {
        return A2(dt, n.length, function(r) {
            return n[r];
        });
    }
    function U(n, r) {
        return Lr(A2(Sr, "Expecting " + n, r));
    }
    function X(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return X(n.b, r.b);
            case 6:
                return n.d === r.d && X(n.b, r.b);
            case 7:
                return n.e === r.e && X(n.b, r.b);
            case 9:
                return n.f === r.f && V(n.g, r.g);
            case 10:
                return n.h === r.h && X(n.b, r.b);
            case 11:
                return V(n.g, r.g);
        }
    }
    function V(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!X(n[e], r[e])) return !1;
        return !0;
    }
    function K(n) {
        return n;
    }
    function J(n) {
        return n;
    }
    function Y(n) {
        return {
            $: 0,
            a: n
        };
    }
    function W(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var nn = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), rn = 0;
    function tn(n) {
        var r = {
            $: 0,
            e: rn++,
            f: n,
            g: null,
            h: []
        };
        return fn(r), r;
    }
    function en(n) {
        return W(function(r) {
            r(Y(tn(n)));
        });
    }
    function an(n, r) {
        n.h.push(r), fn(n);
    }
    var un = F2(function(n, r) {
        return W(function(t) {
            an(n, r), t(Y(0));
        });
    }), cn = !1, on = [];
    function fn(n) {
        if (on.push(n), !cn) {
            for(cn = !0; n = on.shift();)sn(n);
            cn = !1;
        }
    }
    function sn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, fn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var bn = {};
    function dn(n, r, t, e, a) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: a
        };
    }
    function vn(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, a = n.d, u = n.e, i = n.f;
        function c(n) {
            return A2(nn, c, {
                $: 5,
                b: function(r) {
                    var c = r.a;
                    return 0 === r.$ ? A3(a, t, c, n) : u && i ? A4(e, t, c.i, c.j, n) : A3(e, t, u ? c.i : c.j, n);
                }
            });
        }
        return t.h = tn(A2(nn, c, n.b));
    }
    var ln = F2(function(n, r) {
        return W(function(t) {
            n.g(r), t(Y(0));
        });
    }), hn = F2(function(n, r) {
        return A2(un, n.h, {
            $: 0,
            a: r
        });
    });
    function wn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function pn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var $n = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    }), gn = [], mn = !1;
    function yn(n, r, t) {
        if (gn.push({
            p: n,
            q: r,
            r: t
        }), !mn) {
            mn = !0;
            for(var e; e = gn.shift();)xn(e.p, e.q, e.r);
            mn = !1;
        }
    }
    function xn(n, r, t) {
        var e = {};
        for(var a in kn(!0, r, e, null), kn(!1, t, e, null), n)an(n[a], {
            $: "fx",
            a: e[a] || {
                i: d,
                j: d
            }
        });
    }
    function kn(n, r, t, e) {
        switch(r.$){
            case 1:
                var a = r.k, u = function(n, r, t, e) {
                    function a(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? bn[r].e : bn[r].f, a, e);
                }(n, a, e, r.l);
                return void (t[a] = function(n, r, t) {
                    return t = t || {
                        i: d,
                        j: d
                    }, n ? t.i = v(r, t.i) : t.j = v(r, t.j), t;
                }(n, u, t[a]));
            case 2:
                for(var i = r.m; i.b; i = i.b)kn(n, i.a, t, e);
                return;
            case 3:
                return void kn(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    var _n, An = F2(function(n, r) {
        return r;
    });
    var zn = "undefined" != typeof document ? document : {};
    function jn(n, r) {
        n.appendChild(r);
    }
    function Fn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var Ln = F2(function(n, r) {
        return F2(function(t, e) {
            for(var a = [], u = 0; e.b; e = e.b){
                var i = e.a;
                u += i.b || 0, a.push(i);
            }
            return u += a.length, {
                $: 1,
                c: r,
                d: Qn(t),
                e: a,
                f: n,
                b: u
            };
        });
    }), Sn = Ln(void 0), Gn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var a = [], u = 0; e.b; e = e.b){
                var i = e.a;
                u += i.b.b || 0, a.push(i);
            }
            return u += a.length, {
                $: 2,
                c: r,
                d: Qn(t),
                e: a,
                f: n,
                b: u
            };
        });
    }), Rn = Gn(void 0), Tn = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    }), Cn = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), Mn = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), Nn = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), En = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    }), On = /^script$/i, In = /^(on|formAction$)/i, Hn = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function Zn(n) {
        return On.test(n) ? "p" : n;
    }
    var qn, Pn = F2(function(n, r) {
        return "a0" === r.$ ? A2(Cn, r.n, function(n, r) {
            var t = pt(r);
            return {
                $: r.$,
                a: t ? A3(ht, 3 > t ? Bn : Dn, wt(n), r.a) : A2(lt, n, r.a)
            };
        }(n, r.o)) : r;
    }), Bn = F2(function(n, r) {
        return c(n(r.a), r.b);
    }), Dn = F2(function(n, r) {
        return {
            X: n(r.X),
            bV: r.bV,
            bS: r.bS
        };
    });
    function Qn(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, a = t.n, u = t.o;
            if ("a2" !== e) {
                var i = r[e] || (r[e] = {});
                "a3" === e && "class" === a ? Un(i, a, u) : i[a] = u;
            } else "className" === a ? Un(r, a, J(u)) : r[a] = J(u);
        }
        return r;
    }
    function Un(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function Xn(n, r) {
        var t = n.$;
        if (5 === t) return Xn(n.k || (n.k = n.m()), r);
        if (0 === t) return zn.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, a = n.j; 4 === e.$;)"object" != typeof a ? a = [
                a,
                e.j
            ] : a.push(e.j), e = e.k;
            var u = {
                j: a,
                p: r
            };
            return (i = Xn(e, u)).elm_event_node_ref = u, i;
        }
        if (3 === t) return Vn(i = n.h(n.g), r, n.d), i;
        var i = n.f ? zn.createElementNS(n.f, n.c) : zn.createElement(n.c);
        _n && "a" == n.c && i.addEventListener("click", _n(i)), Vn(i, r, n.d);
        for(var c = n.e, o = 0; c.length > o; o++)jn(i, Xn(1 === t ? c[o] : c[o].b, r));
        return i;
    }
    function Vn(n, r, t) {
        for(var e in t){
            var a = t[e];
            "a1" === e ? Kn(n, a) : "a0" === e ? Wn(n, r, a) : "a3" === e ? Jn(n, a) : "a4" === e ? Yn(n, a) : ("value" !== e && "checked" !== e || n[e] !== a) && (n[e] = a);
        }
    }
    function Kn(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Jn(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function Yn(n, r) {
        for(var t in r){
            var e = r[t], a = e.f, u = e.o;
            void 0 !== u ? n.setAttributeNS(a, t, u) : n.removeAttributeNS(a, t);
        }
    }
    function Wn(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var a in t){
            var u = t[a], i = e[a];
            if (u) {
                if (i) {
                    if (i.q.$ === u.$) {
                        i.q = u;
                        continue;
                    }
                    n.removeEventListener(a, i);
                }
                i = nr(r, u), n.addEventListener(a, i, qn && {
                    passive: 2 > pt(u)
                }), e[a] = i;
            } else n.removeEventListener(a, i), e[a] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                qn = !0;
            }
        }));
    } catch (n) {}
    function nr(n, r) {
        function t(r) {
            var e = t.q, a = P(e.a, r);
            if (vt(a)) {
                for(var u, i = pt(e), c = a.a, o = i ? 3 > i ? c.a : c.X : c, f = 1 == i ? c.b : 3 == i && c.bV, s = (f && r.stopPropagation(), (2 == i ? c.b : 3 == i && c.bS) && r.preventDefault(), n); u = s.j;){
                    if ("function" == typeof u) o = u(o);
                    else for(var b = u.length; b--;)o = u[b](o);
                    s = s.p;
                }
                s(o, f);
            }
        }
        return t.q = r, t;
    }
    function rr(n, r) {
        return n.$ == r.$ && X(n.a, r.a);
    }
    function tr(n, r, t, e) {
        var a = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(a), a;
    }
    function er(n, r, t, e) {
        if (n !== r) {
            var a = n.$, u = r.$;
            if (a !== u) {
                if (1 !== a || 2 !== u) return void tr(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), a = 0; t > a; a++)e[a] = r[a].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), u = 1;
            }
            switch(u){
                case 5:
                    for(var i = n.l, c = r.l, o = i.length, f = o === c.length; f && o--;)f = i[o] === c[o];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return er(n.k, r.k, s, 0), void (s.length > 0 && tr(t, 1, e, s));
                case 4:
                    for(var b = n.j, d = r.j, v = !1, l = n.k; 4 === l.$;)v = !0, "object" != typeof b ? b = [
                        b,
                        l.j
                    ] : b.push(l.j), l = l.k;
                    for(var h = r.k; 4 === h.$;)v = !0, "object" != typeof d ? d = [
                        d,
                        h.j
                    ] : d.push(h.j), h = h.k;
                    return v && b.length !== d.length ? void tr(t, 0, e, r) : ((v ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(b, d) : b === d) || tr(t, 2, e, d), void er(l, h, t, e + 1));
                case 0:
                    return void (n.a !== r.a && tr(t, 3, e, r.a));
                case 1:
                    return void ar(n, r, t, e, ir);
                case 2:
                    return void ar(n, r, t, e, cr);
                case 3:
                    if (n.h !== r.h) return void tr(t, 0, e, r);
                    var w = ur(n.d, r.d);
                    w && tr(t, 4, e, w);
                    var p = r.i(n.g, r.g);
                    return void (p && tr(t, 5, e, p));
            }
        }
    }
    function ar(n, r, t, e, a) {
        if (n.c === r.c && n.f === r.f) {
            var u = ur(n.d, r.d);
            u && tr(t, 4, e, u), a(n, r, t, e);
        } else tr(t, 0, e, r);
    }
    function ur(n, r, t) {
        var e;
        for(var a in n)if ("a1" !== a && "a0" !== a && "a3" !== a && "a4" !== a) {
            if (a in r) {
                var u = n[a], i = r[a];
                u === i && "value" !== a && "checked" !== a || "a0" === t && rr(u, i) || ((e = e || {})[a] = i);
            } else (e = e || {})[a] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[a].f,
                o: void 0
            } : "string" == typeof n[a] ? "" : null;
        } else {
            var c = ur(n[a], r[a] || {}, a);
            c && ((e = e || {})[a] = c);
        }
        for(var o in r)o in n || ((e = e || {})[o] = r[o]);
        return e;
    }
    function ir(n, r, t, e) {
        var a = n.e, u = r.e, i = a.length, c = u.length;
        i > c ? tr(t, 6, e, {
            v: c,
            i: i - c
        }) : c > i && tr(t, 7, e, {
            v: i,
            e: u
        });
        for(var o = c > i ? i : c, f = 0; o > f; f++){
            var s = a[f];
            er(s, u[f], t, ++e), e += s.b || 0;
        }
    }
    function cr(n, r, t, e) {
        for(var a = [], u = {}, i = [], c = n.e, o = r.e, f = c.length, s = o.length, b = 0, d = 0, v = e; f > b && s > d;){
            var l = (z = c[b]).a, h = (j = o[d]).a, w = z.b, p = j.b, $ = void 0, g = void 0;
            if (l !== h) {
                var m = c[b + 1], y = o[d + 1];
                if (m) {
                    var x = m.a, k = m.b;
                    g = h === x;
                }
                if (y) {
                    var _ = y.a, A = y.b;
                    $ = l === _;
                }
                if ($ && g) er(w, A, a, ++v), fr(u, a, l, p, d, i), v += w.b || 0, sr(u, a, l, k, ++v), v += k.b || 0, b += 2, d += 2;
                else if ($) v++, fr(u, a, h, p, d, i), er(w, A, a, v), v += w.b || 0, b += 1, d += 2;
                else if (g) sr(u, a, l, w, ++v), v += w.b || 0, er(k, p, a, ++v), v += k.b || 0, b += 2, d += 1;
                else {
                    if (!m || x !== _) break;
                    sr(u, a, l, w, ++v), fr(u, a, h, p, d, i), v += w.b || 0, er(k, A, a, ++v), v += k.b || 0, b += 2, d += 2;
                }
            } else er(w, p, a, ++v), v += w.b || 0, b++, d++;
        }
        for(; f > b;){
            var z;
            v++, sr(u, a, (z = c[b]).a, w = z.b, v), v += w.b || 0, b++;
        }
        for(; s > d;){
            var j, F = F || [];
            fr(u, a, (j = o[d]).a, j.b, void 0, F), d++;
        }
        (a.length > 0 || i.length > 0 || F) && tr(t, 8, e, {
            w: a,
            x: i,
            y: F
        });
    }
    var or = "_elmW6BL";
    function fr(n, r, t, e, a, u) {
        var i = n[t];
        if (!i) return u.push({
            r: a,
            A: i = {
                c: 0,
                z: e,
                r: a,
                s: void 0
            }
        }), void (n[t] = i);
        if (1 === i.c) {
            u.push({
                r: a,
                A: i
            }), i.c = 2;
            var c = [];
            return er(i.z, e, c, i.r), i.r = a, void (i.s.s = {
                w: c,
                A: i
            });
        }
        fr(n, r, t + or, e, a, u);
    }
    function sr(n, r, t, e, a) {
        var u = n[t];
        if (u) {
            if (0 === u.c) {
                u.c = 2;
                var i = [];
                return er(e, u.z, i, a), void tr(r, 9, a, {
                    w: i,
                    A: u
                });
            }
            sr(n, r, t + or, e, a);
        } else {
            var c = tr(r, 9, a, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: a,
                s: c
            };
        }
    }
    function br(n, r, t, e) {
        dr(n, r, t, 0, 0, r.b, e);
    }
    function dr(n, r, t, e, a, u, i) {
        for(var c = t[e], o = c.r; o === a;){
            var f = c.$;
            if (1 === f) br(n, r.k, c.s, i);
            else if (8 === f) c.t = n, c.u = i, (s = c.s.w).length > 0 && dr(n, r, s, 0, a, u, i);
            else if (9 === f) {
                c.t = n, c.u = i;
                var s, b = c.s;
                b && (b.A.s = n, (s = b.w).length > 0 && dr(n, r, s, 0, a, u, i));
            } else c.t = n, c.u = i;
            if (!(c = t[++e]) || (o = c.r) > u) return e;
        }
        var d = r.$;
        if (4 === d) {
            for(var v = r.k; 4 === v.$;)v = v.k;
            return dr(n, v, t, e, a + 1, u, n.elm_event_node_ref);
        }
        for(var l = r.e, h = n.childNodes, w = 0; l.length > w; w++){
            a++;
            var p = 1 === d ? l[w] : l[w].b, $ = a + (p.b || 0);
            if (!(a > o || o > $ || (c = t[e = dr(h[w], p, t, e, a, $, i)]) && (o = c.r) <= u)) return e;
            a = $;
        }
        return e;
    }
    function vr(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], a = e.t, u = lr(a, e);
            a === n && (n = u);
        }
        return n;
    }
    function lr(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, a = Xn(r, t);
                    return a.elm_event_node_ref || (a.elm_event_node_ref = n.elm_event_node_ref), e && a !== n && e.replaceChild(a, n), a;
                }(n, r.s, r.u);
            case 4:
                return Vn(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return vr(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var a = (t = r.s).e, u = n.childNodes[e = t.v]; a.length > e; e++)n.insertBefore(Xn(a[e], r.u), u);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var i = t.A;
                return void 0 !== i.r && n.parentNode.removeChild(n), i.s = vr(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = zn.createDocumentFragment(), e = 0; n.length > e; e++){
                                var a = n[e].A;
                                jn(t, 2 === a.c ? a.s : Xn(a.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = vr(n, t.w);
                    for(var a = t.x, u = 0; a.length > u; u++){
                        var i = a[u], c = i.A, o = 2 === c.c ? c.s : Xn(c.z, r.u);
                        n.insertBefore(o, n.childNodes[i.r]);
                    }
                    return e && jn(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                g(10);
        }
    }
    function hr(n) {
        if (3 === n.nodeType) return Fn(n.textContent);
        if (1 !== n.nodeType) return Fn("");
        for(var r = d, t = n.attributes, e = t.length; e--;){
            var a = t[e];
            r = v(A2(En, a.name, a.value), r);
        }
        var u = n.tagName.toLowerCase(), i = d, c = n.childNodes;
        for(e = c.length; e--;)i = v(hr(c[e]), i);
        return A3(Sn, u, r, i);
    }
    var wr = F4(function(n, r, t, e) {
        return function(n, r, t, e, a, u) {
            var i = A2(q, n, r ? r.flags : void 0);
            vt(i) || g(2);
            var c = {}, o = t(i.a), f = o.a, s = u(d, f), b = function(n, r) {
                var t;
                for(var e in bn){
                    var a = bn[e];
                    a.a && ((t = t || {})[e] = a.a(e, r)), n[e] = vn(a, r);
                }
                return t;
            }(c, d);
            function d(n, r) {
                var t = A2(e, n, f);
                s(f = t.a, r), yn(c, t.b, a(f));
            }
            return yn(c, o.b, a(f)), b ? {
                ports: b
            } : {};
        }(r, e, n.dx, n.d2, n.d_, function(r, t) {
            var e = n.bT && n.bT(r), a = n.d4, u = zn.title, i = zn.body, c = hr(i);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : ($r(e), r(n), 1);
                }
                return function(a, u) {
                    n = a, u ? (r(n), 2 === t && (t = 1)) : (0 === t && $r(e), t = 2);
                };
            }(t, function(n) {
                _n = e;
                var t = a(n), o = Sn("body")(d)(t.bH), f = function(n, r) {
                    var t = [];
                    return er(n, r, t, 0), t;
                }(c, o);
                i = function(n, r, t, e) {
                    return 0 === t.length ? n : (br(n, r, t, e), vr(n, t));
                }(i, c, f, r), c = o, _n = 0, u !== t.bZ && (zn.title = u = t.bZ);
            });
        });
    }), pr = "undefined" != typeof cancelAnimationFrame ? cancelAnimationFrame : function(n) {
        clearTimeout(n);
    }, $r = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    };
    function gr() {
        return Tt(zn.location.href).a || g(1);
    }
    var mr = F2(function(n, r) {
        return A2(Jt, Ct, W(function() {
            history.pushState({}, "", r), n();
        }));
    }), yr = F2(function(n, r) {
        return A2(Jt, Ct, W(function() {
            history.replaceState({}, "", r), n();
        }));
    }), xr = ("undefined" != typeof document && document, "undefined" != typeof window ? window : {
        addEventListener: function() {},
        removeEventListener: function() {}
    }), kr = 1, _r = 2, Ar = 0, zr = l, jr = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, a = n, u = A3(n, t.b, t.c, A3(jr, n, r, t.e));
            n = a, r = u, t = e;
        }
    }), Fr = function(n) {
        return A3(jr, F3(function(n, r, t) {
            return A2(zr, c(n, r), t);
        }), d, n);
    }, Lr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Sr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Gr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Rr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Tr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Cr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Mr = m, Nr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Er = {
        $: 1
    }, Or = s, Ir = E, Hr = F2(function(n, r) {
        return A2(R, n, w(r));
    }), Zr = F2(function(n, r) {
        return h(A2(G, n, r));
    }), qr = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, a = n, u = A2(n, t.a, r);
            n = a, r = u, t = e;
        }
    }), Pr = y, Br = function(n) {
        return A3(qr, zr, d, n);
    }, Dr = 32, Qr = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Ur = [], Xr = _, Vr = F2(function(n, r) {
        return j(r) / j(n);
    }), Kr = function(n) {
        return n;
    }, Jr = Xr(A2(Vr, 2, Dr)), Yr = A4(Qr, 0, Jr, Ur, Ur), Wr = p, nt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, rt = A, tt = function(n) {
        return n.length;
    }, et = F2(function(n, r) {
        return a(n, r) > 0 ? n : r;
    }), at = x, ut = function(n) {
        return {
            $: 0,
            a: n
        };
    }, it = $, ct = F2(function(n, r) {
        for(;;){
            var t = A2(it, Dr, n), e = t.b, a = A2(zr, ut(t.a), r);
            if (!e.b) return Br(a);
            n = e, r = a;
        }
    }), ot = F2(function(n, r) {
        for(;;){
            var t = Xr(r / Dr);
            if (1 === t) return A2(it, Dr, n).a;
            n = A2(ct, n, d), r = t;
        }
    }), ft = F2(function(n, r) {
        if (r.m) {
            var t = r.m * Dr, e = rt(A2(Vr, Dr, t - 1)), a = n ? Br(r.p) : r.p, u = A2(ot, a, r.m);
            return A4(Qr, tt(r.o) + t, A2(et, 5, e * Jr), u, r.o);
        }
        return A4(Qr, tt(r.o), Jr, Ur, r.o);
    }), st = u, bt = F5(function(n, r, t, e, a) {
        for(;;){
            if (0 > r) return A2(ft, !1, {
                p: e,
                m: t / Dr | 0,
                o: a
            });
            var u = nt(A3(Wr, Dr, r, n));
            r -= Dr, e = A2(zr, u, e);
        }
    }), dt = F2(function(n, r) {
        if (n > 0) {
            var t = n % Dr;
            return A5(bt, r, n - t - Dr, n, d, A3(Wr, t, n - t, r));
        }
        return Yr;
    }), vt = function(n) {
        return !n.$;
    }, lt = H, ht = Z, wt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pt = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, $t = function(n) {
        return n;
    }, gt = F6(function(n, r, t, e, a, u) {
        return {
            cl: u,
            cq: r,
            cG: e,
            cI: t,
            cL: n,
            cM: a
        };
    }), mt = C, yt = function(n) {
        return n.length;
    }, xt = T, kt = F2(function(n, r) {
        return 1 > n ? r : A3(xt, n, yt(r), r);
    }), _t = N, At = function(n) {
        return "" === n;
    }, zt = F2(function(n, r) {
        return 1 > n ? "" : A3(xt, 0, n, r);
    }), jt = function(n) {
        for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, a = e; n.length > a; ++a){
            var u = n.charCodeAt(a);
            if (48 > u || u > 57) return Er;
            r = 10 * r + u - 48;
        }
        return a == e ? Er : Nr(45 == t ? -r : r);
    }, Ft = F5(function(n, r, t, e, a) {
        if (At(a) || A2(mt, "@", a)) return Er;
        var u = A2(_t, ":", a);
        if (u.b) {
            if (u.b.b) return Er;
            var i = u.a, c = jt(A2(kt, i + 1, a));
            if (1 === c.$) return Er;
            var o = c;
            return Nr(A6(gt, n, A2(zt, i, a), o, r, t, e));
        }
        return Nr(A6(gt, n, a, Er, r, t, e));
    }), Lt = F4(function(n, r, t, e) {
        if (At(e)) return Er;
        var a = A2(_t, "/", e);
        if (a.b) {
            var u = a.a;
            return A5(Ft, n, A2(kt, u, e), r, t, A2(zt, u, e));
        }
        return A5(Ft, n, "/", r, t, e);
    }), St = F3(function(n, r, t) {
        if (At(t)) return Er;
        var e = A2(_t, "?", t);
        if (e.b) {
            var a = e.a;
            return A4(Lt, n, Nr(A2(kt, a + 1, t)), r, A2(zt, a, t));
        }
        return A4(Lt, n, Er, r, t);
    }), Gt = F2(function(n, r) {
        if (At(r)) return Er;
        var t = A2(_t, "#", r);
        if (t.b) {
            var e = t.a;
            return A3(St, n, Nr(A2(kt, e + 1, r)), A2(zt, e, r));
        }
        return A3(St, n, Er, r);
    }), Rt = M, Tt = function(n) {
        return A2(Rt, "http://", n) ? A2(Gt, 0, A2(kt, 7, n)) : A2(Rt, "https://", n) ? A2(Gt, 1, A2(kt, 8, n)) : Er;
    }, Ct = function() {
        for(;;);
    }, Mt = Y, Nt = Mt(0), Et = F4(function(n, r, t, e) {
        if (e.b) {
            var a = e.a, u = e.b;
            if (u.b) {
                var i = u.a, c = u.b;
                if (c.b) {
                    var o = c.a, f = c.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, a, A2(n, i, A2(n, o, A2(n, f.a, t > 500 ? A3(qr, n, r, Br(s)) : A4(Et, n, r, t + 1, s)))));
                    }
                    return A2(n, a, A2(n, i, A2(n, o, r)));
                }
                return A2(n, a, A2(n, i, r));
            }
            return A2(n, a, r);
        }
        return r;
    }), Ot = F3(function(n, r, t) {
        return A4(Et, n, r, 0, t);
    }), It = F2(function(n, r) {
        return A3(Ot, F2(function(r, t) {
            return A2(zr, n(r), t);
        }), d, r);
    }), Ht = nn, Zt = F2(function(n, r) {
        return A2(Ht, function(r) {
            return Mt(n(r));
        }, r);
    }), qt = F3(function(n, r, t) {
        return A2(Ht, function(r) {
            return A2(Ht, function(t) {
                return Mt(A2(n, r, t));
            }, t);
        }, r);
    }), Pt = function(n) {
        return A3(Ot, qt(zr), Mt(d), n);
    }, Bt = ln, Dt = F2(function(n, r) {
        var t = r;
        return en(A2(Ht, Bt(n), t));
    }), Qt = F3(function(n, r) {
        return A2(Zt, function() {
            return 0;
        }, Pt(A2(It, Dt(n), r)));
    }), Ut = F3(function() {
        return Mt(0);
    }), Xt = F2(function(n, r) {
        return A2(Zt, n, r);
    });
    bn.Task = dn(Nt, Qt, Ut, Xt);
    var Vt, Kt = wn("Task"), Jt = F2(function(n, r) {
        return Kt(A2(Zt, n, r));
    }), Yt = F3(function(n, r, t) {
        return r(n(t));
    }), Wt = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ne = function(n) {
        return {
            $: 2,
            a: n
        };
    }, re = function(n) {
        return {
            $: 3,
            a: n
        };
    }, te = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ee = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ae = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ue = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ie = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ce = F2(function(n, r) {
        return r.$ ? Er : n(r.a);
    }), oe = F3(function(n, r, t) {
        return n(r(t));
    }), fe = function(n) {
        return 0 > n ? Er : Nr(n);
    }, se = F2(function(n, r) {
        return r.$ ? Er : Nr(n(r.a));
    }), be = $t, de = pn(d), ve = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), le = F2(function(n, r) {
        return c(A2(ue, n, ie(A2(ve, be(0), A2(se, A2(oe, be, at(1e3)), A2(ce, fe, r))))), de);
    }), he = {
        $: 0
    }, we = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), pe = {
        $: 0
    }, $e = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ge = function(n) {
        switch(n.$){
            case 0:
            case 1:
            case 2:
                return n.a;
            case 3:
                return n.a.a;
            default:
                return function(n) {
                    return n.a;
                }(n.a);
        }
    }, me = $n, ye = F3(function(n, r, t) {
        var e = t.b;
        return c(n(t.a), A2(me, r, e));
    }), xe = F2(function(n, r) {
        var t = ge(r);
        if (1 === n.$) return c({
            $: 1,
            a: t
        }, de);
        switch(n.a.$){
            case 0:
                return c(function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(t), de);
            case 1:
                return A3(ye, Wt, ne, A2(le, t, n.a.a));
            case 2:
                return A3(ye, ee, re, function(n) {
                    return c(A2(we, n, {
                        _: 100,
                        ak: 1,
                        u: he
                    }), de);
                }(t));
            default:
                return A3(ye, ae, te, function(n) {
                    return c(A2($e, n, pe), de);
                }(t));
        }
    }), ke = F5(function(n, r, t, e, a) {
        return {
            ae: e,
            ai: t,
            aa: r,
            Q: a,
            ap: n
        };
    }), _e = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(zr, n.a, _e(n.b)) : d;
    }, Ae = F2(function(n, r) {
        return Nr(1 === r.$ ? h([
            n
        ]) : A2(zr, n, r.a));
    }), ze = function(n) {
        try {
            return Nr(decodeURIComponent(n));
        } catch (n) {
            return Er;
        }
    }, je = i, Fe = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return Er;
            var t = r.c, e = r.d, a = r.e;
            switch(A2(je, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return Nr(t);
                default:
                    r = a;
                    continue n;
            }
        }
    }), Le = F5(function(n, r, t, e, a) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: a
        };
    }), Se = {
        $: -2
    }, Ge = F5(function(n, r, t, e, a) {
        if (-1 !== a.$ || a.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(Le, n, r, t, e, a);
            var u = e.d;
            return i = e.e, A5(Le, 0, e.b, e.c, A5(Le, 1, u.b, u.c, u.d, u.e), A5(Le, 1, r, t, i, a));
        }
        var i, c = a.b, o = a.c, f = a.d, s = a.e;
        return -1 !== e.$ || e.a ? A5(Le, n, c, o, A5(Le, 0, r, t, e, f), s) : A5(Le, 0, r, t, A5(Le, 1, e.b, e.c, e.d, i = e.e), A5(Le, 1, c, o, f, s));
    }), Re = F3(function(n, r, t) {
        if (-2 === t.$) return A5(Le, 0, n, r, Se, Se);
        var e = t.a, a = t.b, u = t.c, i = t.d, c = t.e;
        switch(A2(je, n, a)){
            case 0:
                return A5(Ge, e, a, u, A3(Re, n, r, i), c);
            case 1:
                return A5(Le, e, a, r, i, c);
            default:
                return A5(Ge, e, a, u, i, A3(Re, n, r, c));
        }
    }), Te = F3(function(n, r, t) {
        var e = A3(Re, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(Le, 1, e.b, e.c, e.d, e.e);
    }), Ce = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return i = t.b, c = t.c, e = t.d, s = t.e, A5(Le, 1, n.b, n.c, A5(Le, 0, r.b, r.c, r.d, r.e), A5(Le, 0, i, c, e, s));
            }
            var e, a = n.d, u = n.e, i = u.b, c = u.c, o = (e = u.d).d, f = e.e, s = u.e;
            return A5(Le, 0, e.b, e.c, A5(Le, 1, n.b, n.c, A5(Le, 0, a.b, a.c, a.d, a.e), o), A5(Le, 1, i, c, f, s));
        }
        return n;
    }, Me = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return f = t.b, s = t.c, b = t.d, d = t.e, A5(Le, 1, e = n.b, a = n.c, A5(Le, 0, r.b, r.c, r.d, c = r.e), A5(Le, 0, f, s, b, d));
            }
            var e = n.b, a = n.c, u = n.d, i = u.d, c = u.e, o = n.e, f = o.b, s = o.c, b = o.d, d = o.e;
            return A5(Le, 0, u.b, u.c, A5(Le, 1, i.b, i.c, i.d, i.e), A5(Le, 1, e, a, c, A5(Le, 0, f, s, b, d)));
        }
        return n;
    }, Ne = F7(function(n, r, t, e, a, u, i) {
        if (-1 !== u.$ || u.a) {
            n: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return Me(r);
                        break n;
                    }
                    return Me(r);
                }
                break n;
            }
            return r;
        }
        return A5(Le, t, u.b, u.c, u.d, A5(Le, 0, e, a, u.e, i));
    }), Ee = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, a = n.d, u = a.d, i = n.e;
            if (1 === a.a) {
                if (-1 !== u.$ || u.a) {
                    var c = Ce(n);
                    if (-1 === c.$) {
                        var o = c.e;
                        return A5(Ge, c.a, c.b, c.c, Ee(c.d), o);
                    }
                    return Se;
                }
                return A5(Le, r, t, e, Ee(a), i);
            }
            return A5(Le, r, t, e, Ee(a), i);
        }
        return Se;
    }, Oe = F2(function(n, r) {
        if (-2 === r.$) return Se;
        var t = r.a, e = r.b, u = r.c, i = r.d, c = r.e;
        if (0 > a(n, e)) {
            if (-1 === i.$ && 1 === i.a) {
                var o = i.d;
                if (-1 !== o.$ || o.a) {
                    var f = Ce(r);
                    if (-1 === f.$) {
                        var s = f.e;
                        return A5(Ge, f.a, f.b, f.c, A2(Oe, n, f.d), s);
                    }
                    return Se;
                }
                return A5(Le, t, e, u, A2(Oe, n, i), c);
            }
            return A5(Le, t, e, u, A2(Oe, n, i), c);
        }
        return A2(Ie, n, A7(Ne, n, r, t, e, u, i, c));
    }), Ie = F2(function(n, r) {
        if (-1 === r.$) {
            var e = r.a, a = r.b, u = r.c, i = r.d, c = r.e;
            if (t(n, a)) {
                var o = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(c);
                return -1 === o.$ ? A5(Ge, e, o.b, o.c, i, Ee(c)) : Se;
            }
            return A5(Ge, e, a, u, i, A2(Oe, n, c));
        }
        return Se;
    }), He = F2(function(n, r) {
        var t = A2(Oe, n, r);
        return -1 !== t.$ || t.a ? t : A5(Le, 1, t.b, t.c, t.d, t.e);
    }), Ze = F3(function(n, r, t) {
        var e = r(A2(Fe, n, t));
        return e.$ ? A2(He, n, t) : A3(Te, n, e.a, t);
    }), qe = F2(function(n, r) {
        var t = A2(Zr, "=", n);
        if (t.b && t.b.b && !t.b.b.b) {
            var e = t.b.a, a = ze(t.a);
            if (1 === a.$) return r;
            var u = a.a, i = ze(e);
            return 1 === i.$ ? r : A3(Ze, u, Ae(i.a), r);
        }
        return r;
    }), Pe = Se, Be = F2(function(n, r) {
        var t;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var r = n.a, t = r.aa;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return Nr(r.Q);
                    }
                    return Nr(r.Q);
                }
                return Er;
            }
        }(n(A5(ke, d, function(n) {
            var r = A2(Zr, "/", n);
            return _e(r.b && "" === r.a ? r.b : r);
        }(r.cG), 1 === (t = r.cM).$ ? Pe : A3(Ot, qe, Pe, A2(Zr, "&", t.a)), r.cl, $t)));
    }), De = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Qe = {
        $: 0
    }, Ue = {
        $: 2
    }, Xe = {
        $: 3
    }, Ve = F2(function(n, r) {
        return function(t) {
            return r(A2(ve, d, A2(Fe, n, t)));
        };
    }), Ke = F2(function(n, r) {
        return A5(ke, r.ap, r.aa, r.ai, r.ae, n(r.Q));
    }), Je = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = r.ae, a = r.ai, u = r.aa, i = r.ap;
            return A2(It, Ke(r.Q), t(A5(ke, i, u, a, e, n)));
        };
    }), Ye = F2(function(n, r) {
        return r.b ? A3(Ot, zr, r, n) : n;
    }), We = function(n) {
        return A3(Ot, Ye, d, n);
    }, na = F2(function(n, r) {
        return We(A2(It, n, r));
    }), ra = F2(function(n, r) {
        var t = n, e = r;
        return function(n) {
            return A2(na, e, t(n));
        };
    }), ta = F2(function(n, r) {
        return A2(ra, n, function(n) {
            var r = n;
            return function(n) {
                var t = n.ai;
                return h([
                    A5(ke, n.ap, n.aa, t, n.ae, (0, n.Q)(r(t)))
                ]);
            };
        }(r));
    }), ea = function(n) {
        return function(r) {
            var e = r.Q, a = r.ae, u = r.ai, i = r.aa, c = r.ap;
            if (i.b) {
                var o = i.a, f = i.b;
                return t(o, n) ? h([
                    A5(ke, A2(zr, o, c), f, u, a, e)
                ]) : d;
            }
            return d;
        };
    }, aa = function(n) {
        return h([
            n
        ]);
    }, ua = (Vt = h([
        A2(Je, Qe, aa),
        A2(Je, De, A2(ta, ea("countdown"), A2(Ve, "t", function(n) {
            return n.b && !n.b.b ? jt(n.a) : Er;
        }))),
        A2(Je, Ue, ea("restwatch")),
        A2(Je, Xe, ea("stopwatch"))
    ]), function(n) {
        return A2(na, function(r) {
            return r(n);
        }, Vt);
    }), ia = function(n) {
        return A2(Be, ua, n);
    }, ca = F3(function(n, r, t) {
        return A2(xe, ia(r), {
            $: 0,
            a: t
        });
    }), oa = $n, fa = pn(d), sa = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ba = function(n) {
        return {
            $: 3,
            a: n
        };
    }, da = function(n) {
        return {
            $: 0,
            a: n
        };
    }, va = F3(function(n, r, t) {
        return {
            bR: t,
            cP: r,
            cX: n
        };
    }), la = Mt(A3(va, d, Er, 0)), ha = W(function(n) {
        n(Y(Date.now()));
    }), wa = W(function(n) {
        var r = $r(function() {
            n(Y(Date.now()));
        });
        return function() {
            pr(r);
        };
    }), pa = hn, $a = en, ga = F3(function(n, r, t) {
        var e, a = t.bR, u = t.cP, i = c(u, r);
        return 1 === i.a.$ ? i.b.b ? A2(Ht, function(n) {
            return A2(Ht, function(t) {
                return Mt(A3(va, r, Nr(n), t));
            }, ha);
        }, $a(A2(Ht, pa(n), wa))) : la : i.b.b ? Mt(A3(va, r, u, a)) : A2(Ht, function() {
            return la;
        }, (e = i.a.a, W(function(n) {
            var r = e.f;
            2 === r.$ && r.c && r.c(), e.f = null, n(Y(0));
        })));
    }), ma = $t, ya = F3(function(n, r, t) {
        var e = t.bR, a = t.cX, u = function(t) {
            return A2(Bt, n, (0, t.a)(t.$ ? r - e : ma(r)));
        };
        return A2(Ht, function(n) {
            return A2(Ht, function() {
                return Mt(A3(va, a, Nr(n), r));
            }, Pt(A2(It, u, a)));
        }, $a(A2(Ht, pa(n), wa)));
    });
    bn["Browser.AnimationManager"] = dn(la, ga, ya, 0, F2(function(n, r) {
        return r.$ ? {
            $: 1,
            a: A2(oe, n, r.a)
        } : da(A2(oe, n, r.a));
    }));
    var xa, ka, _a, Aa, za, ja, Fa, La, Sa = wn("Browser.AnimationManager"), Ga = function(n) {
        return Sa(da(n));
    }, Ra = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ta = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ca = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Ma = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Na = F, Ea = F4(function(n, r, t, e) {
        return {
            at: e,
            aA: t,
            cS: r,
            aI: n
        };
    }), Oa = 3432918353, Ia = 461845907, Ha = F2(function(n, r) {
        return (65535 & r) * n + (((r >>> 16) * n & 65535) << 16);
    }), Za = F2(function(n, r) {
        return r << n | r >>> 32 - n;
    }), qa = S, Pa = F2(function(n, r) {
        return A2(Ha, 5, A2(Za, 13, n ^ A2(Ha, Ia, A2(Za, 15, A2(Ha, Oa, r))))) + 3864292196;
    }), Ba = F2(function(n, r) {
        var t, e, a = r.aA | (255 & (55296 > (e = (t = n).charCodeAt(0)) || e > 56319 ? e : 1024 * (e - 55296) + t.charCodeAt(1) - 56320 + 65536)) << r.aI;
        return 24 === r.aI ? {
            at: r.at + 1,
            aA: 0,
            cS: A2(Pa, r.cS, a),
            aI: 0
        } : {
            at: r.at + 1,
            aA: a,
            cS: r.cS,
            aI: r.aI + 8
        };
    }), Da = F2(function(n, r) {
        var t, e, a, u;
        return ((u = A2(Ha, 3266489909, (a = A2(Ha, 2246822507, (e = ((t = A3(qa, Ba, A4(Ea, 0, n, 0, 0), r)).aA ? t.cS ^ A2(Ha, Ia, A2(Za, 15, A2(Ha, Oa, t.aA))) : t.cS) ^ t.at) ^ e >>> 16)) ^ a >>> 13)) ^ u >>> 16) >>> 0;
    }), Qa = k, Ua = function(n) {
        n: for(;;)switch(n){
            case 0:
                return "0";
            case 1:
                return "1";
            case 2:
                return "2";
            case 3:
                return "3";
            case 4:
                return "4";
            case 5:
                return "5";
            case 6:
                return "6";
            case 7:
                return "7";
            case 8:
                return "8";
            case 9:
                return "9";
            case 10:
                return "a";
            case 11:
                return "b";
            case 12:
                return "c";
            case 13:
                return "d";
            case 14:
                return "e";
            case 15:
                return "f";
            default:
                continue n;
        }
    }, Xa = F2(function(n, r) {
        for(;;){
            if (16 > r) return A2(zr, Ua(r), n);
            n = A2(zr, Ua(A2(Qa, 16, r)), n), r = r / 16 | 0;
        }
    }), Va = function(n) {
        var r;
        return A2(Na, "_", w(0 > (r = A2(Da, 15739, n)) ? A2(zr, "-", A2(Xa, d, -r)) : A2(Xa, d, r)).join(""));
    }, Ka = F2(function(n, r) {
        var t = n.c;
        return n.b && A2(Fe, t, r).$ ? A3(Te, t, Va(t), r) : r;
    }), Ja = F2(function(n, r) {
        return A2(Nn, function(n) {
            return "innerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), function(n) {
            return "string" == typeof n && Hn.test(n) ? "" : n;
        }(r));
    }), Ya = K, Wa = F2(function(n, r) {
        var t = r.a;
        if (r.b) {
            var e = A2(Fe, r.c, n);
            return A2(Ja, "className", Ya(e.$ ? "_unstyled" : e.a));
        }
        return t;
    }), nu = F2(function(n, r) {
        return A2(En, function(n) {
            return In.test(n) ? "data-" + n : n;
        }(n), function(n) {
            return Hn.test(n) ? "" : n;
        }(r));
    }), ru = F2(function(n, r) {
        var t = r.a;
        if (r.b) {
            var e = A2(Fe, r.c, n);
            return A2(nu, "class", e.$ ? "_unstyled" : e.a);
        }
        return t;
    }), tu = function(n) {
        return Rn(Zn(n));
    }, eu = F2(function(n, r) {
        return A2(Gn, n, Zn(r));
    }), au = function(n) {
        return Sn(Zn(n));
    }, uu = F2(function(n, r) {
        return A2(Ln, n, Zn(r));
    }), iu = F2(function(n, r) {
        var t = n.a, e = n.b, a = r.a, u = r.b;
        switch(e.$){
            case 4:
                return c(A2(zr, c(t, b = e.a), a), u);
            case 0:
                var i = e.a, o = e.c, f = A3(qr, cu, c(d, A3(qr, Ka, u, w = e.b)), o), s = f.a, b = A3(au, i, A2(It, Wa(p = f.b), w), Br(s));
                return c(A2(zr, c(t, b), a), p);
            case 1:
                var v = e.a, l = (i = e.b, o = e.d, A3(qr, cu, c(d, A3(qr, Ka, u, w = e.c)), o));
                return s = l.a, b = A4(uu, v, i, A2(It, Wa(p = l.b), w), Br(s)), c(A2(zr, c(t, b), a), p);
            case 2:
                i = e.a, o = e.c;
                var h = A3(qr, iu, c(d, A3(qr, Ka, u, w = e.b)), o);
                return s = h.a, b = A3(tu, i, A2(It, Wa(p = h.b), w), Br(s)), c(A2(zr, c(t, b), a), p);
            default:
                v = e.a, i = e.b, o = e.d;
                var w, p, $ = A3(qr, iu, c(d, A3(qr, Ka, u, w = e.c)), o);
                return s = $.a, b = A4(eu, v, i, A2(It, Wa(p = $.b), w), Br(s)), c(A2(zr, c(t, b), a), p);
        }
    }), cu = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 4:
                return c(A2(zr, f = n.a, t), e);
            case 0:
                var a = n.a, u = n.c, i = A3(qr, cu, c(d, A3(qr, Ka, e, l = n.b)), u), o = i.a, f = A3(au, a, A2(It, Wa(h = i.b), l), Br(o));
                return c(A2(zr, f, t), h);
            case 1:
                var s = n.a, b = (a = n.b, u = n.d, A3(qr, cu, c(d, A3(qr, Ka, e, l = n.c)), u));
                return o = b.a, f = A4(uu, s, a, A2(It, ru(h = b.b), l), Br(o)), c(A2(zr, f, t), h);
            case 2:
                a = n.a, u = n.c;
                var v = A3(qr, iu, c(d, A3(qr, Ka, e, l = n.b)), u);
                return o = v.a, f = A3(tu, a, A2(It, Wa(h = v.b), l), Br(o)), c(A2(zr, f, t), h);
            default:
                s = n.a, a = n.b, u = n.d;
                var l, h, w = A3(qr, iu, c(d, A3(qr, Ka, e, l = n.c)), u);
                return o = w.a, f = A4(eu, s, a, A2(It, ru(h = w.b), l), Br(o)), c(A2(zr, f, t), h);
        }
    }), ou = function(n) {
        return h([
            n
        ]);
    }, fu = Fn, su = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, a = n, u = A3(n, t.b, t.c, A3(su, n, r, t.d));
            n = a, r = u, t = e;
        }
    }), bu = F3(function(n, r, t) {
        return A2(Hr, r, A2(Zr, n, t));
    }), du = F3(function(n, r, t) {
        return t + "\n" + A3(bu, "", r, n);
    }), vu = F2(function(n, r) {
        return A3(su, F3(function(r, t, e) {
            return e + "\n" + A3(bu, ".", "#" + n + "." + t, r);
        }), "", r);
    }), lu = F2(function(n, r) {
        var t = function() {
            if (r.$) {
                var n = r.a, t = r.c;
                return A2(vu, n, r.b) + "\n" + A2(vu, n + " ", t);
            }
            return A3(su, du, "", r.a);
        }();
        return A3(au, "span", h([
            A2(nu, "style", "display: none;"),
            A2(nu, "class", "elm-css-style-wrapper")
        ]), h([
            A3(au, "style", n.$ ? d : h([
                A2(nu, "nonce", n.a)
            ]), ou(fu(t)))
        ]));
    }), hu = F4(function(n, r, t, e) {
        var a = A3(qr, cu, c(d, A3(qr, Ka, Pe, t)), e), u = a.a, i = a.b, o = A2(lu, n, Ma(i)), f = A2(It, Wa(i), t);
        return A3(au, r, f, A2(zr, o, Br(u)));
    }), wu = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var e = r.b;
            if (t(n, r.a.a)) return !0;
            r = e;
        }
    }), pu = F2(function(n, r) {
        n: for(;;){
            if (r.b) {
                var t = r.b, e = "_" + r.a.a;
                if (A2(wu, e, t)) {
                    n = e, r = t;
                    continue n;
                }
                return e;
            }
            return n;
        }
    }), $u = F3(function(n, r, t) {
        return c(A2(pu, "_", t), A2(lu, n, r));
    }), gu = F4(function(n, r, t, e) {
        var a = A3(qr, iu, c(d, A3(qr, Ka, Pe, t)), e), u = a.a, i = a.b, o = A3($u, n, Ma(i), u), f = A2(It, Wa(i), t);
        return A3(tu, r, f, A2(zr, o, Br(u)));
    }), mu = F5(function(n, r, t, e, a) {
        var u = A3(qr, iu, c(d, A3(qr, Ka, Pe, e)), a), i = u.a, o = u.b, f = A3($u, n, Ma(o), i), s = A2(It, ru(o), e);
        return A4(eu, r, t, s, A2(zr, f, Br(i)));
    }), yu = F5(function(n, r, t, e, a) {
        var u = A3(qr, cu, c(d, A3(qr, Ka, Pe, e)), a), i = u.a, o = u.b, f = A2(lu, n, Ma(o)), s = A2(It, ru(o), e);
        return A4(uu, r, t, s, A2(zr, f, Br(i)));
    }), xu = function(n) {
        switch(n.$){
            case 4:
                return n.a;
            case 0:
                return A4(hu, Er, n.a, n.b, n.c);
            case 1:
                return A5(yu, Er, n.a, n.b, n.c, n.d);
            case 2:
                return A4(gu, Er, n.a, n.b, n.c);
            default:
                return A5(mu, Er, n.a, n.b, n.c, n.d);
        }
    }, ku = function(n) {
        var r = n.bZ;
        return {
            bH: A2(It, xu, n.bH),
            bZ: r
        };
    }, _u = mr, Au = function(n) {
        return _u(n);
    }, zu = F2(function(n, r) {
        return 1 === n.$ ? r : r + ":" + Ir(n.a);
    }), ju = F3(function(n, r, t) {
        return 1 === r.$ ? t : b(t, b(n, r.a));
    }), Fu = F2(function(n, r) {
        var t = r.b;
        return c(n(r.a), t);
    }), Lu = yr, Su = function(n) {
        return Lu(n);
    }, Gu = function(n) {
        return n;
    }, Ru = function(n) {
        return n.a + "=" + n.b;
    }, Tu = F2(function(n, r) {
        return "/" + (A2(Hr, "/", n) + function(n) {
            return n.b ? "?" + A2(Hr, "&", A2(It, Ru, n)) : "";
        }(r));
    }), Cu = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Mu = function(n) {
        return encodeURIComponent(n);
    }, Nu = F2(function(n, r) {
        return A2(Cu, Mu(n), Mu(r));
    }), Eu = function(n) {
        n: for(;;)switch(n.$){
            case 0:
                return A2(Tu, d, d);
            case 1:
                if (1 === n.a.$) return A2(Tu, h([
                    "countdown"
                ]), d);
                var r = n.a.a;
                if (r > 0) return A2(Tu, h([
                    "countdown"
                ]), h([
                    A2(Nu, "t", Ir(r))
                ]));
                n = De(Er);
                continue n;
            case 2:
                return A2(Tu, h([
                    "restwatch"
                ]), d);
            default:
                return A2(Tu, h([
                    "stopwatch"
                ]), d);
        }
    }, Ou = F2(function(n, r) {
        return c(A2(ue, n, r), r.$ ? de : A2(Su, n, Eu(De(Nr(r.a / 1e3 | 0)))));
    }), Iu = F2(function(n, r) {
        return n ? r % n : 0;
    }), Hu = function(n) {
        var r = n / 1e3 | 0, t = r / 60 | 0;
        return {
            a_: t / 60 | 0,
            a1: A2(Iu, 60, t),
            a9: A2(Iu, 60, r)
        };
    }, Zu = function(n) {
        return be(A2(et, 0, 1e3 * (60 * (60 * n.a_ + n.a1) + n.a9)));
    }, qu = F2(function(n, r) {
        if (r.$) return r;
        var t = Hu(r.a);
        switch(n.$){
            case 0:
                return ie(Zu(f(t, {
                    a_: n.a
                })));
            case 1:
                return ie(Zu(f(t, {
                    a1: n.a
                })));
            default:
                return ie(Zu(f(t, {
                    a9: n.a
                })));
        }
    }), Pu = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Bu = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Du = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Qu = F3(function(n, r, t) {
        return A2(n, r, t);
    }), Uu = F3(function(n, r, t) {
        return ma(A3(Qu, n, r, t));
    }), Xu = Uu(Pr), Vu = function(n) {
        return A2(Xu, n.b, n.a);
    }, Ku = (xa = "alarm", ka = $t, function(n) {
        bn[n] && g(3);
    }(xa), bn[xa] = {
        e: An,
        u: ka,
        a: function(n) {
            var r = [], t = bn[n].u, e = W(function(n) {
                var r = setTimeout(function() {
                    n(Y(0));
                }, 0);
                return function() {
                    clearTimeout(r);
                };
            });
            return bn[n].b = e, bn[n].c = F3(function(n, a) {
                for(; a.b; a = a.b)for(var u = r, i = J(t(a.a)), c = 0; u.length > c; c++)u[c](i);
                return e;
            }), {
                subscribe: function(n) {
                    r.push(n);
                },
                unsubscribe: function(n) {
                    var t = (r = r.slice()).indexOf(n);
                    0 > t || r.splice(t, 1);
                }
            };
        }
    }, wn(xa)), Ju = Ku(Ya("load")), Yu = Qu(st), Wu = Ku(Ya("play")), ni = function(n) {
        return n.a;
    }, ri = Uu(Mr), ti = function(n) {
        return ma(n);
    }, ei = F2(function(n, r) {
        return c(r, A2(ri, r, ti(n)));
    }), ai = Ku(Ya("stop")), ui = function(n) {
        return (n / 1e3 | 0) > 0;
    }, ii = F2(function(n, r) {
        return ui(n) ? c({
            $: 1,
            a: n
        }, Ju) : c(r, de);
    }), ci = F2(function(n, r) {
        var t = c(n, r);
        switch(t.a.$){
            case 0:
                switch(t.b.$){
                    case 0:
                    case 5:
                        return A2(ii, o = t.b.a, r);
                    case 3:
                        var e = t.b;
                        return c(A2(Bu, o = e.a, e.b), Ju);
                    default:
                        return c(r, de);
                }
            case 1:
                switch(t.b.$){
                    case 1:
                        return c(ie(o = t.b.a), de);
                    case 2:
                        var a = t.b;
                        return c(A2(Pu, o = a.a, Vu(a.b)), de);
                    case 4:
                        var u = t.b;
                        return c(A2(Pu, o = u.a, u.b), de);
                    default:
                        return c(r, de);
                }
            case 2:
                return c(ie(ni(r)), ai);
            default:
                switch(t.b.$){
                    case 1:
                        return c(A2(Du, o = t.b.a, A2(ei, o, s = t.a.a)), de);
                    case 2:
                        var i = t.b, o = i.a, f = i.b.b;
                        return A2(Yu, f, s = t.a.a) ? c({
                            $: 5,
                            a: o
                        }, Wu) : c(A2(Du, o, c(s, f)), de);
                    case 4:
                        var s, b = t.b;
                        return c(A2(Du, o = b.a, A2(ei, b.b, s = t.a.a)), de);
                    default:
                        return c(r, de);
                }
        }
    }), oi = F2(function(n, r) {
        var t = r.a, e = r.b, a = c(n, e);
        if (a.a.$) return A2(Ou, t, A2(qu, a.a.a, e));
        var u = a.a.a;
        return A2(Fu, ue(t), A2(ci, u, e));
    }), fi = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), si = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), bi = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), di = F2(function(n, r) {
        return A2(Yu, n, r) ? n : r;
    }), vi = z, li = function(n) {
        return n / 100;
    }, hi = A2(oe, Kr, Gu), wi = F4(function(n, r, t, e) {
        var a = n.b, u = e.a, i = e.b - li(n.a) * hi(t), o = ma(vi(i + hi(t) * li(a)));
        return A2(r, t, c(A2(di, u, o), o));
    }), pi = F2(function(n, r) {
        switch(r.$){
            case 3:
                return A4(wi, n, si, r.a, r.b);
            case 7:
                return A4(wi, n, fi, r.a, r.b);
            case 8:
                return A4(wi, n, bi, r.a, r.b);
            default:
                return r;
        }
    }), $i = function(n) {
        return {
            $: 5,
            a: n
        };
    }, gi = function(n) {
        return {
            $: 2,
            a: n
        };
    }, mi = {
        $: 1
    }, yi = F2(function(n, r) {
        return ma(n(r));
    }), xi = function(n) {
        return yi(A2(oe, A2(oe, vi, at(n)), Kr));
    }, ki = F3(function(n, r, t) {
        var e = A2(Xu, t.b, t.a), a = A2(xi, li(n), e);
        return c(r, A2(ri, r, a));
    }), _i = F2(function(n, r) {
        return c(A2(ri, r.a, A2(Xu, n, r.b)), n);
    }), Ai = F3(function(n, r, t) {
        var e = c(n, t);
        switch(e.a.$){
            case 0:
                switch(e.b.$){
                    case 0:
                    case 4:
                        return c(mi, Ju);
                    case 5:
                        return c({
                            $: 6,
                            a: v = e.b.a
                        }, Ju);
                    default:
                        return c(t, de);
                }
            case 1:
                switch(e.b.$){
                    case 0:
                    case 1:
                        return c(he, de);
                    case 2:
                        var a = A3(ki, r, (v = e.b.a).b, v), u = Vu(v);
                        return c(A2(si, u, a), de);
                    case 5:
                        return a = A3(ki, r, (v = e.b.a).b, v), u = Vu(v), c(A2(bi, u, a), de);
                    case 6:
                        return u = Vu(v = e.b.a), c(A2(bi, u, v), de);
                    case 7:
                        var i = e.b;
                        return c(A2(bi, u = i.a, v = i.b), de);
                    default:
                        return c(t, de);
                }
            case 2:
                switch(e.b.$){
                    case 1:
                        return c(he, de);
                    case 2:
                    case 6:
                        return c($i(v = e.b.a), de);
                    case 3:
                        var o = e.b;
                        return c(A2(fi, u = o.a, v = o.b), de);
                    case 8:
                        var f = e.b;
                        return c(A2(fi, u = f.a, v = f.b), de);
                    default:
                        return c(t, de);
                }
            case 3:
                return c(he, ai);
            default:
                switch(e.b.$){
                    case 1:
                        return c(gi(c(b = e.a.a, b)), de);
                    case 2:
                        return c(gi(c(e.b.a.a, b = e.a.a)), de);
                    case 6:
                        return c(gi(A2(_i, b = e.a.a, v = e.b.a)), de);
                    case 3:
                        var s = e.b;
                        return u = s.a, A2(Yu, a = s.b.b, b = e.a.a) ? c(function(n) {
                            return {
                                $: 4,
                                a: n
                            };
                        }(u), Wu) : c(A2(si, u, c(b, a)), de);
                    case 8:
                        var b = e.a.a, d = e.b, v = d.b;
                        return c(A2(si, u = d.a, A3(ki, 100, b, v)), de);
                    default:
                        return c(t, de);
                }
        }
    }), zi = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 2:
                return A2(Fu, function(n) {
                    return A2(we, t, f(e, {
                        u: n
                    }));
                }, A3(Ai, n.a, e._, e.u));
            case 0:
                var a = n.a;
                return c(A2(we, t, {
                    _: a,
                    ak: 1,
                    u: A2(pi, c(e._, a), e.u)
                }), de);
            default:
                return c(A2(we, t, f(e, {
                    ak: n.a
                })), de);
        }
    }), ji = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Fi = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Li = {
        $: 1
    }, Si = F2(function(n, r) {
        return c(A2(Xu, n, ti(r)), n);
    }), Gi = F2(function(n, r) {
        var t = r.a, e = r.b, a = c(n, e);
        switch(a.a.$){
            case 0:
                switch(a.b.$){
                    case 0:
                        return c(A2($e, t, Li), de);
                    case 3:
                        return c(A2($e, t, {
                            $: 4,
                            a: a.b.a
                        }), de);
                    default:
                        return c(A2($e, t, e), de);
                }
            case 1:
                switch(a.b.$){
                    case 1:
                        return c(A2($e, t, pe), de);
                    case 2:
                        return c(A2($e, t, ji(Vu(a.b.a))), de);
                    case 4:
                        return c(A2($e, t, ji(a.b.a)), de);
                    default:
                        return c(A2($e, t, e), de);
                }
            case 2:
                return c(A2($e, t, pe), de);
            default:
                switch(a.b.$){
                    case 1:
                        return c(A2($e, t, Fi(c(u = a.a.a, u))), de);
                    case 4:
                        return c(A2($e, t, Fi(A2(Si, u = a.a.a, a.b.a))), de);
                    case 2:
                        var u;
                        return c(A2($e, t, Fi(c(a.b.a.a, u = a.a.a))), de);
                    default:
                        return c(A2($e, t, e), de);
                }
        }
    }), Ri = F2(function(n, r) {
        var t = c(n, r);
        switch(t.a.$){
            case 0:
                var e = t.a.a;
                if (e.$) return c(r, function(n) {
                    return A2(Jt, Ct, W(function() {
                        try {
                            xr.location = n;
                        } catch (n) {
                            zn.location.reload(!1);
                        }
                    }));
                }(e.a));
                var a = e.a;
                return c(r, A2(Au, ge(r), function(n) {
                    return A3(ju, "#", n.cl, A3(ju, "?", n.cM, b(A2(zu, n.cI, b(n.cL ? "https://" : "http://", n.cq)), n.cG)));
                }(a)));
            case 1:
                return A2(xe, ia(a = t.a.a), r);
            case 2:
                return 3 === t.b.$ ? A3(ye, Wt, ne, A2(oi, t.a.a, t.b.a)) : c(r, de);
            case 3:
                return 4 === t.b.$ ? A3(ye, ee, re, A2(zi, t.a.a, t.b.a)) : c(r, de);
            default:
                return 5 === t.b.$ ? A3(ye, ae, te, A2(Gi, t.a.a, t.b.a)) : c(r, de);
        }
    }), Ti = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Ci = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), Mi = function(n) {
        return !n;
    }, Ni = F2(function(n, r) {
        return !A2(Ci, A2(oe, Mi, n), r);
    }), Ei = function(n) {
        return !n.b;
    }, Oi = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 0:
                return Ei(n.a.c) ? c(t, e) : c(t, A2(zr, n, e));
            case 1:
                return c(t, A2(Ni, function(n) {
                    return Ei(n.c);
                }, n.b) ? e : A2(zr, n, e));
            case 2:
                return Ei(n.b) ? c(t, e) : c(t, A2(zr, n, e));
            case 3:
                return c(t, A2(zr, n, e));
            case 4:
            case 5:
            case 7:
            case 8:
                return Ei(n.a) ? c(t, e) : c(t, A2(zr, n, e));
            case 6:
                var a = n.a;
                return At(a.di) ? c(t, e) : c(A3(Te, a.dF, a.di, t), e);
            default:
                return c(t, A2(Ni, function(n) {
                    return Ei(n.b);
                }, n.a) ? e : A2(zr, n, e));
        }
    }), Ii = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Hi = F2(function(n, r) {
        return A2(Ye, A2(It, function(n) {
            return Ii({
                di: n.b,
                dF: n.a
            });
        }, Fr(n)), r);
    }), Zi = function(n) {
        var r = A3(Ot, Oi, c(Pe, d), n);
        return A2(Hi, r.a, r.b);
    }, qi = F4(function(n, r, t, e) {
        n: for(;;){
            if (t.b) {
                if (t.b.b) {
                    var a = n, u = r, i = t.b, c = e + (n(t.a) + (r + ""));
                    n = a, r = u, t = i, e = c;
                    continue n;
                }
                return e + (n(t.a) + "");
            }
            return e;
        }
    }), Pi = F3(function(n, r, t) {
        return A4(qi, n, r, t, "");
    }), Bi = function(n) {
        return "(" + n.cj + A2(ve, "", A2(se, Or(": "), n.Q)) + ")";
    }, Di = function(n) {
        var r = F3(function(n, r, t) {
            return n + " " + A2(Hr, " and ", A2(zr, function(n) {
                switch(n){
                    case 0:
                        return "print";
                    case 1:
                        return "screen";
                    default:
                        return "speech";
                }
            }(r), A2(It, Bi, t)));
        });
        switch(n.$){
            case 0:
                return A3(Pi, Bi, " and ", n.a);
            case 1:
                return A3(r, "only", n.a, n.b);
            case 2:
                return A3(r, "not", n.a, n.b);
            default:
                return n.a;
        }
    }, Qi = F2(function(n, r) {
        return '@import "' + n + Di(r) + '"';
    }), Ui = function(n) {
        var r = n.b;
        return A3(Pi, Qi(n.a), "\n", r);
    }, Xi = function(n) {
        return "@namespace " + n.a + '"' + n.b + '"';
    }, Vi = L, Ki = function(n) {
        return "::" + n;
    }, Ji = function(n) {
        switch(n.$){
            case 0:
                return "." + n.a;
            case 1:
                return "#" + n.a;
            case 2:
                return ":" + n.a;
            default:
                return "[" + n.a + "]";
        }
    }, Yi = function(n) {
        switch(n.$){
            case 0:
            default:
                return b(n.a, A3(Pi, Ji, "", r = n.b));
            case 1:
                var r;
                return Ei(r = n.a) ? "*" : A3(Pi, Ji, "", r);
        }
    }, Wi = function(n) {
        var r = n.b;
        return function(n) {
            switch(n){
                case 0:
                    return "+";
                case 1:
                    return "~";
                case 2:
                    return ">";
                default:
                    return "";
            }
        }(n.a) + " " + Yi(r);
    }, nc = function(n) {
        var r = n.b, t = n.c, e = A2(zr, Yi(n.a), A2(It, Wi, r)), a = A2(ve, "", A2(se, Ki, t));
        return A2(Vi, A2(Hr, " ", e), a);
    }, rc = function(n) {
        var r = n.c;
        return A3(Pi, nc, ",", A2(zr, n.a, n.b)) + "{" + function(n) {
            return A3(Pi, function(n) {
                return n + ";";
            }, "", n);
        }(r) + "}";
    }, tc = function(n) {
        switch(n.$){
            case 0:
                return rc(n.a);
            case 1:
                var r = n.b;
                return "@media " + A3(Pi, Di, ", ", n.a) + "{" + A3(Pi, rc, "\n", r) + "}";
            case 2:
            case 3:
            case 4:
            case 5:
            case 7:
            case 8:
            default:
                return "TODO";
            case 6:
                return "@keyframes " + n.a.dF + "{" + n.a.di + "}";
        }
    }, ec = function(n) {
        return {
            $: 8,
            a: n
        };
    }, ac = function(n) {
        return {
            $: 5,
            a: n
        };
    }, uc = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ic = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), cc = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), oc = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fc = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), sc = function(n) {
        return {
            $: 7,
            a: n
        };
    }, bc = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), dc = F2(function(n, r) {
        return r.b ? r.b.b ? A2(zr, r.a, A2(dc, n, r.b)) : h([
            n(r.a)
        ]) : r;
    }), vc = F2(function(n, r) {
        return A3(cc, r.a, r.b, b(r.c, h([
            n
        ])));
    }), lc = F2(function(n, r) {
        if (!r.b) return r;
        if (r.b.b) return A2(zr, r.a, A2(lc, n, r.b));
        switch(r.a.$){
            case 0:
                return h([
                    oc(A2(vc, n, r.a.a))
                ]);
            case 1:
                var t = r.a, e = t.b;
                return h([
                    A2(bc, t.a, A2(dc, vc(n), e))
                ]);
            default:
                return r;
        }
    }), hc = F2(function(n, r) {
        if (r.b.b) {
            var t = r.a, e = r.b, a = (i = r.c, A2(It, n, e)), u = n(t);
            return h([
                A3(cc, t, e, i),
                A3(cc, u, a, d)
            ]);
        }
        var i, c = r.a;
        return h([
            A3(cc, c, d, i = r.c),
            A3(cc, n(c), d, d)
        ]);
    }), wc = F2(function(n, r) {
        return A3(ic, r.a, r.b, Nr(n));
    }), pc = F2(function(n, r) {
        return A2(hc, wc(n), r);
    }), $c = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), gc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), mc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, yc = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(gc, r.a, b(r.b, h([
                    n
                ])));
            case 1:
                return mc(b(r.a, h([
                    n
                ])));
            default:
                return A2($c, r.a, b(r.b, h([
                    n
                ])));
        }
    }), xc = F2(function(n, r) {
        if (r.b) {
            if (r.b.b) return A2(zr, r.a, A2(xc, n, r.b));
            var t = r.a;
            return h([
                c(t.a, A2(yc, n, t.b))
            ]);
        }
        return d;
    }), kc = F2(function(n, r) {
        if (r.b.b) return t = r.c, A3(ic, r.a, A2(xc, n, r.b), t);
        var t = r.c;
        return A3(ic, A2(yc, n, r.a), d, t);
    }), _c = F2(function(n, r) {
        return A2(hc, kc(n), r);
    }), Ac = function(n) {
        n: for(;;){
            if (n.b) {
                if (n.a.$) {
                    n = t = n.b;
                    continue n;
                }
                var r = n.a.a, t = n.b;
                return b(A2(zr, r.a, r.b), Ac(t));
            }
            return d;
        }
    }, zc = F5(function(n, r, t, e, a) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t,
            d: e,
            e: a
        };
    }), jc = F2(function(n, r) {
        n: for(;;){
            if (!r.b) return r;
            if (r.b.b) break n;
            switch(r.a.$){
                case 0:
                    return A2(It, oc, n(s = r.a.a));
                case 1:
                    if (r.a.b.b) {
                        if (r.a.b.b.b) {
                            var t = r.a, e = t.b, a = e.a, u = A2(jc, n, h([
                                A2(bc, t.a, e.b)
                            ]));
                            if (u.b && 1 === u.a.$ && !u.b.b) {
                                var i = u.a;
                                return h([
                                    A2(bc, i.a, A2(zr, a, i.b))
                                ]);
                            }
                            return u;
                        }
                        var c = r.a;
                        return h([
                            A2(bc, c.a, n(s = c.b.a))
                        ]);
                    }
                    break n;
                case 2:
                    var o = r.a;
                    return h([
                        A2(fc, o.a, A2(jc, n, o.b))
                    ]);
                case 3:
                    var f = r.a, s = f.e;
                    return A2(It, A4(zc, f.a, f.b, f.c, f.d), n(s));
                default:
                    return r;
            }
        }
        return A2(zr, a = r.a, A2(jc, n, r.b));
    }), Fc = function(n) {
        n: for(;;){
            if (n.b) {
                if (n.b.b) {
                    n = n.b;
                    continue n;
                }
                return Nr(h([
                    n.a
                ]));
            }
            return Er;
        }
    }, Lc = function(n) {
        var r, t = function(n) {
            return n.b ? A2(zr, n.a, t(n.b)) : d;
        };
        return h([
            (r = t(n), {
                $: 9,
                a: r
            })
        ]);
    }, Sc = F2(function(n, r) {
        return r.$ ? r : A2(bc, n, h([
            r.a
        ]));
    }), Gc = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(zr, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), Rc = F2(function(n, r) {
        return Br(A3(Gc, n, r, d));
    }), Tc = F3(function(n, r, t) {
        if (r > 0) {
            var e = c(r, t);
            n: for(;;){
                r: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break n;
                        break r;
                    }
                    switch(e.a){
                        case 1:
                            break n;
                        case 2:
                            var a = e.b;
                            return h([
                                a.a,
                                a.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var u = e.b, i = u.b;
                                return h([
                                    u.a,
                                    i.a,
                                    i.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var o = e.b, f = o.b, s = f.b, b = s.b, v = b.b;
                                return A2(zr, o.a, A2(zr, f.a, A2(zr, s.a, A2(zr, b.a, n > 1e3 ? A2(Rc, r - 4, v) : A3(Tc, n + 1, r - 4, v)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return h([
                e.b.a
            ]);
        }
        return d;
    }), Cc = F2(function(n, r) {
        return A3(Tc, 0, n, r);
    }), Mc = F5(function(n, r, t, e, a) {
        return a.$ ? a : A5(zc, n, r, t, e, a.a);
    }), Nc = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(bc, n, h([
                    r.a
                ]));
            case 1:
                var t = r.b;
                return A2(bc, b(n, r.a), t);
            case 2:
                var e = r.b;
                return A2(fc, r.a, A2(It, Nc(n), e));
            case 3:
                return A5(zc, r.a, r.b, r.c, r.d, r.e);
            default:
                return r;
        }
    }), Ec = function(n) {
        return n;
    }, Oc = F4(function(n, r, e, a) {
        var u = function(n) {
            var r;
            return A2(ve, d, (r = n).b ? Nr(r.b) : Er);
        }, i = A2(Ic, r, A2(ve, d, Fc(a))), o = function() {
            var n, r = c((n = i).b ? Nr(n.a) : Er, function(n) {
                n: for(;;){
                    if (n.b) {
                        if (n.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return Nr(n.a);
                    }
                    return Er;
                }
            }(a));
            if (r.a.$ || r.b.$) return a;
            var e, u = r.a.a, o = r.b.a;
            return b(A2(Cc, (e = a, A3(qr, F2(function(n, r) {
                return r + 1;
            }), 0, e) - 1), a), h([
                t(o, u) ? o : u
            ]));
        }();
        return b(o, b(u(A2(ve, d, A2(se, function(r) {
            return We(A2(dc, Ic(n), A2(It, ou, A2(jc, e, r))));
        }, Fc(a)))), u(i)));
    }), Ic = F2(function(n, r) {
        if (!n.b) return r;
        switch(n.a.$){
            case 0:
                return A2(Ic, i = n.b, A2(lc, n.a.a, r));
            case 1:
                var t = n.a;
                return A4(Oc, $ = t.b, i = n.b, _c(t.a), r);
            case 2:
                var e = n.a, a = e.a, u = e.b, i = n.b, o = F2(function(n, r) {
                    var t = n.c, e = r.b, u = r.c;
                    return A3(ic, n.a, b(n.b, A2(zr, c(a, r.a), e)), function(n) {
                        n: for(;;){
                            if (n.b) {
                                var r = n.a;
                                if (1 === r.$) {
                                    n = n.b;
                                    continue n;
                                }
                                return r;
                            }
                            return Er;
                        }
                    }(h([
                        u,
                        t
                    ])));
                }), f = function(n) {
                    switch(n.$){
                        case 0:
                            var t = n.a, e = t.a, a = t.b, u = t.c, i = A2(na, function(n) {
                                return A2(It, o(n), A2(zr, e, a));
                            }, Ac(r)), c = i.b ? h([
                                oc(A3(cc, i.a, i.b, d))
                            ]) : d;
                            return A2(Ic, u, c);
                        case 1:
                            return A2(qc, n.a, n.b);
                        case 2:
                            return A2(Pc, n.a, n.b);
                        case 3:
                            var f = n.e;
                            return A2(It, A4(Mc, n.a, n.b, n.c, n.d), Hc(f));
                        case 4:
                            return h([
                                uc(n.a)
                            ]);
                        case 5:
                            return h([
                                ac(n.a)
                            ]);
                        case 6:
                            return h([
                                sc(n.a)
                            ]);
                        case 7:
                            return h([
                                ec(n.a)
                            ]);
                        default:
                            return Lc(n.a);
                    }
                };
                return We(b(h([
                    A2(Ic, i, r)
                ]), A2(It, f, A2(na, Ec, u))));
            case 3:
                var s = n.a;
                return A4(Oc, $ = s.b, i = n.b, pc(s.a), r);
            case 5:
                var v = n.a.a, l = (i = n.b, Va(v));
                return A2(Ye, A2(Ic, i, A2(lc, "animation-name:" + l, r)), h([
                    Ii({
                        di: v,
                        dF: l
                    })
                ]));
            case 4:
                var w = n.a, p = w.a, $ = w.b, g = (i = n.b, function() {
                    var n = Ac(r);
                    if (n.b) {
                        var t = n.a, e = n.b;
                        return A2(It, Sc(p), A2(Ic, $, ou(oc(A3(cc, t, e, d)))));
                    }
                    return d;
                }());
                return b(A2(Ic, i, r), g);
            default:
                return A2(Ic, b(n.a.a, i = n.b), r);
        }
    }), Hc = function(n) {
        return A2(Ic, n.c, h([
            oc(A3(cc, n.a, n.b, d))
        ]));
    }, Zc = function(n) {
        if (n.b) {
            var r = n.b;
            return b(Bc(n.a), Zc(r));
        }
        return d;
    }, qc = F2(function(n, r) {
        return A2(na, function(r) {
            return A2(It, Nc(n), Hc(r));
        }, r);
    }), Pc = F2(function(n, r) {
        var t = Zc(A2(na, Ec, r));
        return h([
            A2(fc, n, t)
        ]);
    }), Bc = function(n) {
        switch(n.$){
            case 0:
                return Hc(r = n.a);
            case 1:
                return A2(qc, n.a, n.b);
            case 2:
                return A2(Pc, n.a, n.b);
            case 3:
                var r = n.e;
                return A2(It, A4(Mc, n.a, n.b, n.c, n.d), Hc(r));
            case 4:
                return h([
                    uc(n.a)
                ]);
            case 5:
                return h([
                    ac(n.a)
                ]);
            case 6:
                return h([
                    sc(n.a)
                ]);
            case 7:
                return h([
                    ec(n.a)
                ]);
            default:
                return Lc(n.a);
        }
    }, Dc = function(n) {
        var r, t, e;
        return function(n) {
            var r = n.dj, t = n.cz, e = n.cr;
            return A2(ve, "", A2(se, function(n) {
                return '@charset "' + n + '"';
            }, n.cb)) + (A3(Pi, Ui, "\n", e) + (A3(Pi, Xi, "\n", t) + (A3(Pi, tc, "\n", r) + "")));
        }(function(n) {
            var r = n.cz, t = n.cr;
            return {
                cb: n.cb,
                dj: Zi(n.dj),
                cr: t,
                cz: r
            };
        }((t = (r = n).cz, e = r.cr, {
            cb: r.cb,
            dj: Zc(A2(na, Ec, r.cU)),
            cr: e,
            cz: t
        })));
    }, Qc = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Uc = F2(function(n, r) {
        var t;
        return h([
            (t = A3(Qc, A3(ic, r, d, Er), d, n), {
                $: 0,
                a: t
            })
        ]);
    }), Xc = function(n) {
        return {
            cb: Er,
            cr: d,
            cz: d,
            cU: n
        };
    }, Vc = mc(h([
        {
            $: 0,
            a: ""
        }
    ])), Kc = function(n) {
        return n.b ? Dc(Xc(h([
            A2(Uc, n, Vc)
        ]))) : "";
    }, Jc = function(n) {
        var r = Kc(n);
        return A3(Ti, A2(nu, "", ""), !0, r);
    }, Yc = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Wc = Yc, no = Wc, ro = no("div"), to = F2(function(n, r) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n + ":" + r);
    }), eo = A2(to, "display", "flex"), ao = A2(to, "flex-direction", "column"), uo = function(n) {
        return {
            $: 4,
            a: n
        };
    }, io = uo, co = F2(function(n, r) {
        return A2(Uc, r, A2($c, n, d));
    }), oo = h([
        A2(co, "*, ::before, ::after", h([
            A2(to, "--tw-border-spacing-x", "0"),
            A2(to, "--tw-border-spacing-y", "0"),
            A2(to, "--tw-translate-x", "0"),
            A2(to, "--tw-translate-y", "0"),
            A2(to, "--tw-rotate", "0"),
            A2(to, "--tw-skew-x", "0"),
            A2(to, "--tw-skew-y", "0"),
            A2(to, "--tw-scale-x", "1"),
            A2(to, "--tw-scale-y", "1"),
            A2(to, "--tw-pan-x", " "),
            A2(to, "--tw-pan-y", " "),
            A2(to, "--tw-pinch-zoom", " "),
            A2(to, "--tw-scroll-snap-strictness", "proximity"),
            A2(to, "--tw-gradient-from-position", " "),
            A2(to, "--tw-gradient-via-position", " "),
            A2(to, "--tw-gradient-to-position", " "),
            A2(to, "--tw-ordinal", " "),
            A2(to, "--tw-slashed-zero", " "),
            A2(to, "--tw-numeric-figure", " "),
            A2(to, "--tw-numeric-spacing", " "),
            A2(to, "--tw-numeric-fraction", " "),
            A2(to, "--tw-ring-inset", " "),
            A2(to, "--tw-ring-offset-width", "0px"),
            A2(to, "--tw-ring-offset-color", "#fff"),
            A2(to, "--tw-ring-color", "rgb(59 130 246 / 0.5)"),
            A2(to, "--tw-ring-offset-shadow", "0 0 #0000"),
            A2(to, "--tw-ring-shadow", "0 0 #0000"),
            A2(to, "--tw-shadow", "0 0 #0000"),
            A2(to, "--tw-shadow-colored", "0 0 #0000"),
            A2(to, "--tw-blur", " "),
            A2(to, "--tw-brightness", " "),
            A2(to, "--tw-contrast", " "),
            A2(to, "--tw-grayscale", " "),
            A2(to, "--tw-hue-rotate", " "),
            A2(to, "--tw-invert", " "),
            A2(to, "--tw-saturate", " "),
            A2(to, "--tw-sepia", " "),
            A2(to, "--tw-drop-shadow", " "),
            A2(to, "--tw-backdrop-blur", " "),
            A2(to, "--tw-backdrop-brightness", " "),
            A2(to, "--tw-backdrop-contrast", " "),
            A2(to, "--tw-backdrop-grayscale", " "),
            A2(to, "--tw-backdrop-hue-rotate", " "),
            A2(to, "--tw-backdrop-invert", " "),
            A2(to, "--tw-backdrop-opacity", " "),
            A2(to, "--tw-backdrop-saturate", " "),
            A2(to, "--tw-backdrop-sepia", " "),
            A2(to, "--tw-contain-size", " "),
            A2(to, "--tw-contain-layout", " "),
            A2(to, "--tw-contain-paint", " "),
            A2(to, "--tw-contain-style", " ")
        ])),
        A2(co, "::backdrop", h([
            A2(to, "--tw-border-spacing-x", "0"),
            A2(to, "--tw-border-spacing-y", "0"),
            A2(to, "--tw-translate-x", "0"),
            A2(to, "--tw-translate-y", "0"),
            A2(to, "--tw-rotate", "0"),
            A2(to, "--tw-skew-x", "0"),
            A2(to, "--tw-skew-y", "0"),
            A2(to, "--tw-scale-x", "1"),
            A2(to, "--tw-scale-y", "1"),
            A2(to, "--tw-pan-x", " "),
            A2(to, "--tw-pan-y", " "),
            A2(to, "--tw-pinch-zoom", " "),
            A2(to, "--tw-scroll-snap-strictness", "proximity"),
            A2(to, "--tw-gradient-from-position", " "),
            A2(to, "--tw-gradient-via-position", " "),
            A2(to, "--tw-gradient-to-position", " "),
            A2(to, "--tw-ordinal", " "),
            A2(to, "--tw-slashed-zero", " "),
            A2(to, "--tw-numeric-figure", " "),
            A2(to, "--tw-numeric-spacing", " "),
            A2(to, "--tw-numeric-fraction", " "),
            A2(to, "--tw-ring-inset", " "),
            A2(to, "--tw-ring-offset-width", "0px"),
            A2(to, "--tw-ring-offset-color", "#fff"),
            A2(to, "--tw-ring-color", "rgb(59 130 246 / 0.5)"),
            A2(to, "--tw-ring-offset-shadow", "0 0 #0000"),
            A2(to, "--tw-ring-shadow", "0 0 #0000"),
            A2(to, "--tw-shadow", "0 0 #0000"),
            A2(to, "--tw-shadow-colored", "0 0 #0000"),
            A2(to, "--tw-blur", " "),
            A2(to, "--tw-brightness", " "),
            A2(to, "--tw-contrast", " "),
            A2(to, "--tw-grayscale", " "),
            A2(to, "--tw-hue-rotate", " "),
            A2(to, "--tw-invert", " "),
            A2(to, "--tw-saturate", " "),
            A2(to, "--tw-sepia", " "),
            A2(to, "--tw-drop-shadow", " "),
            A2(to, "--tw-backdrop-blur", " "),
            A2(to, "--tw-backdrop-brightness", " "),
            A2(to, "--tw-backdrop-contrast", " "),
            A2(to, "--tw-backdrop-grayscale", " "),
            A2(to, "--tw-backdrop-hue-rotate", " "),
            A2(to, "--tw-backdrop-invert", " "),
            A2(to, "--tw-backdrop-opacity", " "),
            A2(to, "--tw-backdrop-saturate", " "),
            A2(to, "--tw-backdrop-sepia", " "),
            A2(to, "--tw-contain-size", " "),
            A2(to, "--tw-contain-layout", " "),
            A2(to, "--tw-contain-paint", " "),
            A2(to, "--tw-contain-style", " ")
        ])),
        A2(co, "*,\n::before,\n::after", h([
            A2(to, "box-sizing", "border-box"),
            A2(to, "border-width", "0"),
            A2(to, "border-style", "solid"),
            A2(to, "border-color", "#e5e7eb")
        ])),
        A2(co, "::before,\n::after", h([
            A2(to, "--tw-content", "''")
        ])),
        A2(co, "html,\n:host", h([
            A2(to, "line-height", "1.5"),
            A2(to, "-webkit-text-size-adjust", "100%"),
            A2(to, "-moz-tab-size", "4"),
            A2(to, "tab-size", "4"),
            A2(to, "font-family", 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'),
            A2(to, "font-feature-settings", "normal"),
            A2(to, "font-variation-settings", "normal"),
            A2(to, "-webkit-tap-highlight-color", "transparent")
        ])),
        A2(co, "body", h([
            A2(to, "margin", "0"),
            A2(to, "line-height", "inherit")
        ])),
        A2(co, "hr", h([
            A2(to, "height", "0"),
            A2(to, "color", "inherit"),
            A2(to, "border-top-width", "1px")
        ])),
        A2(co, "abbr:where([title])", h([
            A2(to, "text-decoration", "underline dotted")
        ])),
        A2(co, "h1,\nh2,\nh3,\nh4,\nh5,\nh6", h([
            A2(to, "font-size", "inherit"),
            A2(to, "font-weight", "inherit")
        ])),
        A2(co, "a", h([
            A2(to, "color", "inherit"),
            A2(to, "text-decoration", "inherit")
        ])),
        A2(co, "b,\nstrong", h([
            A2(to, "font-weight", "bolder")
        ])),
        A2(co, "code,\nkbd,\nsamp,\npre", h([
            A2(to, "font-family", 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace'),
            A2(to, "font-feature-settings", "normal"),
            A2(to, "font-variation-settings", "normal"),
            A2(to, "font-size", "1em")
        ])),
        A2(co, "small", h([
            A2(to, "font-size", "80%")
        ])),
        A2(co, "sub,\nsup", h([
            A2(to, "font-size", "75%"),
            A2(to, "line-height", "0"),
            A2(to, "position", "relative"),
            A2(to, "vertical-align", "baseline")
        ])),
        A2(co, "sub", h([
            A2(to, "bottom", "-0.25em")
        ])),
        A2(co, "sup", h([
            A2(to, "top", "-0.5em")
        ])),
        A2(co, "table", h([
            A2(to, "text-indent", "0"),
            A2(to, "border-color", "inherit"),
            A2(to, "border-collapse", "collapse")
        ])),
        A2(co, "button,\ninput,\noptgroup,\nselect,\ntextarea", h([
            A2(to, "font-family", "inherit"),
            A2(to, "font-feature-settings", "inherit"),
            A2(to, "font-variation-settings", "inherit"),
            A2(to, "font-size", "100%"),
            A2(to, "font-weight", "inherit"),
            A2(to, "line-height", "inherit"),
            A2(to, "letter-spacing", "inherit"),
            A2(to, "color", "inherit"),
            A2(to, "margin", "0"),
            A2(to, "padding", "0")
        ])),
        A2(co, "button,\nselect", h([
            A2(to, "text-transform", "none")
        ])),
        A2(co, "button,\ninput:where([type='button']),\ninput:where([type='reset']),\ninput:where([type='submit'])", h([
            A2(to, "-webkit-appearance", "button"),
            A2(to, "background-color", "transparent"),
            A2(to, "background-image", "none")
        ])),
        A2(co, ":-moz-focusring", h([
            A2(to, "outline", "auto")
        ])),
        A2(co, ":-moz-ui-invalid", h([
            A2(to, "box-shadow", "none")
        ])),
        A2(co, "progress", h([
            A2(to, "vertical-align", "baseline")
        ])),
        A2(co, "::-webkit-inner-spin-button,\n::-webkit-outer-spin-button", h([
            A2(to, "height", "auto")
        ])),
        A2(co, "[type='search']", h([
            A2(to, "-webkit-appearance", "textfield"),
            A2(to, "outline-offset", "-2px")
        ])),
        A2(co, "::-webkit-search-decoration", h([
            A2(to, "-webkit-appearance", "none")
        ])),
        A2(co, "::-webkit-file-upload-button", h([
            A2(to, "-webkit-appearance", "button"),
            A2(to, "font", "inherit")
        ])),
        A2(co, "summary", h([
            A2(to, "display", "list-item")
        ])),
        A2(co, "blockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre", h([
            A2(to, "margin", "0")
        ])),
        A2(co, "fieldset", h([
            A2(to, "margin", "0"),
            A2(to, "padding", "0")
        ])),
        A2(co, "legend", h([
            A2(to, "padding", "0")
        ])),
        A2(co, "ol,\nul,\nmenu", h([
            A2(to, "list-style", "none"),
            A2(to, "margin", "0"),
            A2(to, "padding", "0")
        ])),
        A2(co, "dialog", h([
            A2(to, "padding", "0")
        ])),
        A2(co, "textarea", h([
            A2(to, "resize", "vertical")
        ])),
        A2(co, "input::placeholder,\ntextarea::placeholder", h([
            A2(to, "opacity", "1"),
            A2(to, "color", "#9ca3af")
        ])),
        A2(co, 'button,\n[role="button"]', h([
            A2(to, "cursor", "pointer")
        ])),
        A2(co, ":disabled", h([
            A2(to, "cursor", "default")
        ])),
        A2(co, "img,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject", h([
            A2(to, "display", "block"),
            A2(to, "vertical-align", "middle")
        ])),
        A2(co, "img,\nvideo", h([
            A2(to, "max-width", "100%"),
            A2(to, "height", "auto")
        ])),
        A2(co, '[hidden]:where(:not([hidden="until-found"]))', h([
            A2(to, "display", "none")
        ]))
    ]), fo = A2(to, "min-height", "100vh"), so = function(n) {
        return {
            $: 6,
            a: n
        };
    }, bo = F4(function(n, r, t, e) {
        if (e.$) return A2(to, n, e.a);
        var a = e.a, u = e.b, i = e.c, o = e.d, f = c(e.e, t);
        if (f.a.$) {
            if (f.b.$) return A2(to, n, r(a + "(" + u + " " + i + " " + o + " / 1.0)"));
            var s = f.b.a;
            return so(h([
                A2(to, s, "1"),
                A2(to, n, r(a + "(" + u + " " + i + " " + o + " / var(" + s + "))"))
            ]));
        }
        return A2(to, n, r(a + "(" + u + " " + i + " " + o + " / " + f.a.a + ")"));
    }), vo = function(n) {
        return so(h([
            A2(to, "--tw-bg-opacity", "1"),
            A4(bo, "background-color", function(n) {
                return n;
            }, Nr("--tw-bg-opacity, 1"), n)
        ]));
    }, lo = A2(to, "border-bottom-width", "1px"), ho = function(n) {
        return so(h([
            A2(to, "--tw-border-opacity", "1"),
            A4(bo, "border-color", function(n) {
                return n;
            }, Nr("--tw-border-opacity, 1"), n)
        ]));
    }, wo = A2(to, "grid-column-start", "2"), po = A2(to, "display", "grid"), $o = A2(to, "grid-template-columns", "1fr auto 1fr"), go = no("h1"), mo = no("a"), yo = F2(function(n, r) {
        return A3(Ti, A2(nu, n, r), !1, "");
    }), xo = yo("d"), ko = F4(function(n, r, t, e) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), _o = ko, Ao = _o("http://www.w3.org/2000/svg"), zo = Ao("path"), jo = yo("fill"), Fo = Ao("svg"), Lo = yo("viewBox"), So = F2(function(n, r) {
        return A2(Fo, A2(zr, Lo("0 0 20 20"), A2(zr, jo("currentColor"), n)), r);
    }), Go = function(n) {
        var r = Kc(n);
        return A3(Ti, A2(nu, "", ""), !0, r);
    }, Ro = A2(to, "height", "1.5rem"), To = F2(function(n, r) {
        return A3(Ti, A2(Ja, n, r), !1, "");
    }), Co = F2(function(n, r) {
        return A2(To, n, Ya(r));
    }), Mo = function(n) {
        var r;
        return r = Eu(n), A2(Co, "href", r);
    }, No = A2(to, "align-items", "center"), Eo = function(n) {
        return uo(fu(n));
    }, Oo = A2(to, "width", "1.5rem"), Io = function(n) {
        var r;
        return 1 === n ? Eo("") : A2(mo, h([
            Jc(h([
                eo,
                No
            ])),
            Mo(Qe)
        ]), h([
            (r = h([
                Go(h([
                    Ro,
                    Oo
                ]))
            ]), A2(So, r, h([
                A2(zo, h([
                    xo("M7.05 9.293L6.343 10 12 15.657l1.414-1.414L9.172 10l4.242-4.243L12 4.343z")
                ]), d)
            ])))
        ]));
    }, Ho = A2(to, "margin-left", "auto"), Zo = A2(to, "margin-right", "auto"), qo = no("nav"), Po = F5(function(n, r, t, e, a) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e,
            e: a
        };
    }), Bo = {
        $: 1
    }, Do = A5(Po, "rgb", "251", "146", "60", Bo), Qo = A5(Po, "rgb", "249", "115", "22", Bo), Uo = A2(to, "padding", "0.5rem"), Xo = so(h([
        A2(to, "--tw-shadow", "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)"),
        A2(to, "--tw-shadow-colored", "0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color)"),
        A2(to, "box-shadow", "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)")
    ])), Vo = A2(to, "position", "sticky"), Ko = A2(to, "text-align", "center"), Jo = function(n) {
        return so(h([
            A2(to, "--tw-text-opacity", "1"),
            A4(bo, "color", function(n) {
                return n;
            }, Nr("--tw-text-opacity, 1"), n)
        ]));
    }, Yo = A2(to, "top", "0px"), Wo = A5(Po, "rgb", "255", "255", "255", Bo), nf = F2(function(n, r) {
        var t = n;
        return A2(qo, h([
            Jc(h([
                po,
                $o,
                Uo,
                vo(Qo),
                Jo(Wo),
                lo,
                ho(Do),
                Xo,
                Vo,
                Yo
            ]))
        ]), h([
            A2(ro, h([
                Jc(h([
                    Zo
                ]))
            ]), h([
                Io(r)
            ])),
            A2(go, h([
                Jc(h([
                    wo,
                    Ko
                ]))
            ]), h([
                Eo(t)
            ])),
            A2(ro, h([
                Jc(h([
                    Ho
                ]))
            ]), d)
        ]));
    }), rf = F2(function(n, r) {
        var t, e = r.bH, a = r.bZ;
        return {
            bH: h([
                (t = oo, io(A3(au, "span", h([
                    A2(nu, "style", "display: none;"),
                    A2(nu, "class", "elm-css-style-wrapper")
                ]), ou(A3(au, "style", d, ou(fu(Dc(Xc(t))))))))),
                A2(ro, h([
                    Jc(h([
                        fo,
                        eo,
                        ao
                    ]))
                ]), A2(zr, A2(nf, a, n), e))
            ]),
            bZ: a + " - Timers"
        };
    }), tf = {
        bH: d,
        bZ: ""
    }, ef = no("audio"), af = K, uf = F2(function(n, r) {
        return A2(To, n, af(r));
    }), cf = uf("controls"), of = Co("id"), ff = no("source"), sf = function(n) {
        return A2(Co, "src", n);
    }, bf = A2(ef, h([
        of("alarm"),
        cf(!1)
    ]), h([
        A2(ff, h([
            sf("/audio/analog-watch-alarm_daniel-simion.mp3")
        ]), d),
        A2(ff, h([
            sf("/audio/analog-watch-alarm_daniel-simion.wav")
        ]), d)
    ])), df = function(n) {
        return {
            $: 3,
            a: n
        };
    }, vf = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), lf = function(n) {
        return vf(A2(It, df, n));
    }, hf = so(h([
        A2(to, "width", "100%"),
        A2(lf, h([
            "(min-width: 1536px)"
        ]), h([
            A2(to, "max-width", "1536px")
        ])),
        A2(lf, h([
            "(min-width: 1280px)"
        ]), h([
            A2(to, "max-width", "1280px")
        ])),
        A2(lf, h([
            "(min-width: 1024px)"
        ]), h([
            A2(to, "max-width", "1024px")
        ])),
        A2(lf, h([
            "(min-width: 768px)"
        ]), h([
            A2(to, "max-width", "768px")
        ])),
        A2(lf, h([
            "(min-width: 640px)"
        ]), h([
            A2(to, "max-width", "640px")
        ]))
    ])), wf = A2(to, "flex-grow", "1"), pf = no("footer"), $f = A2(to, "gap", "0.5rem"), gf = A2(to, "grid-template-columns", "repeat(2, minmax(0, 1fr))"), mf = A2(to, "line-height", "1.5"), yf = no("main"), xf = so(h([
        A2(to, "margin-left", "auto"),
        A2(to, "margin-right", "auto")
    ])), kf = A2(to, "padding", "0.75rem"), _f = so(h([
        A2(to, "padding-top", "0.5rem"),
        A2(to, "padding-bottom", "0.5rem")
    ])), Af = A2(to, "font-size", "1.25rem"), zf = function(n) {
        return {
            $: 1,
            a: n
        };
    }, jf = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ff = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Lf = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Sf = A2(to, "flex-direction", "row"), Gf = A2(to, "font-family", 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace'), Rf = A2(to, "line-height", "1"), Tf = no("p"), Cf = so(h([
        A2(to, "padding-top", "1rem"),
        A2(to, "padding-bottom", "1rem")
    ])), Mf = A2(to, "align-self", "center"), Nf = yo("datetime"), Ef = A2(to, "user-select", "all"), Of = no("time"), If = function(n) {
        return A2(Na, n, "");
    }, Hf = F2(function(n, r) {
        return r ? b(Ir(r), If(n)) : "";
    }), Zf = F2(function(n, r) {
        return n ? r % n : 0;
    }), qf = function(n) {
        var r = n, t = r / 1e3 | 0, e = t / 60 | 0, a = e / 60 | 0;
        return {
            bi: a / 24 | 0,
            a_: A2(Zf, 24, a),
            bO: A2(Zf, 1e3, r),
            a1: A2(Zf, 60, e),
            a9: A2(Zf, 60, t)
        };
    }, Pf = function(n) {
        var r, t, e, a, u;
        return 1e3 > n ? "PT0S" : (u = (r = qf(n)).bi, (a = r.a_) + (e = r.a1) + (t = r.a9) ? "P" + A2(Hf, "D", u) + "T" + (A2(Hf, "H", a) + (A2(Hf, "M", e) + A2(Hf, "S", t))) : "P" + A2(Hf, "D", u));
    }, Bf = F2(function(n, r) {
        return A2(Of, h([
            Nf(Pf(r)),
            Jc(h([
                Ef
            ]))
        ]), h([
            Eo(n(r))
        ]));
    }), Df = F3(function(n, r, t) {
        return n > 0 ? A3(Df, n >> 1, b(r, r), 1 & n ? b(t, r) : t) : t;
    }), Qf = F2(function(n, r) {
        return A3(Df, n, r, "");
    }), Uf = F3(function(n, r, t) {
        return b(A2(Qf, n - yt(t), If(r)), t);
    }), Xf = A2(oe, A2(Uf, 2, "0"), Ir), Vf = A2(oe, A2(Uf, 3, "0"), Ir), Kf = function(n) {
        var r = qf(n);
        return r.a_ ? Xf(24 * r.bi + r.a_) + ":" + Xf(r.a1) + ":" + Xf(r.a9) : Xf(r.a1) + ":" + Xf(r.a9) + "." + A2(zt, 1, Vf(r.bO)) + "\xa0";
    }, Jf = Bf(Kf), Yf = function(n) {
        return {
            a4: n,
            a5: n,
            aG: n,
            a6: n
        };
    }, Wf = F2(function(n, r) {
        var t = n.a4, e = n.a5, a = n.aG, u = n.a6;
        switch(r.$){
            case 0:
                return u(r.a);
            case 1:
                return a(r.a);
            case 2:
                return a(Vu(r.b));
            case 3:
                return e(r.b);
            case 4:
                return a(r.b);
            default:
                return t(be(0));
        }
    }), ns = function(n) {
        return A2(Wf, Yf($t), n);
    }, rs = function(n) {
        return Jf(ns(n));
    }, ts = A2(to, "font-size", "2.25rem"), es = no("button"), as = function(n) {
        return A2(So, n, h([
            A2(zo, h([
                xo("M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z")
            ]), d)
        ]));
    }, us = A2(to, "height", "1rem"), is = A2(to, "justify-content", "center"), cs = Cn, os = F2(function(n, r) {
        return A3(Ti, A2(cs, n, r), !1, "");
    }), fs = F2(function(n, r) {
        return A2(os, n, function(n) {
            return {
                $: 0,
                a: n
            };
        }(r));
    }), ss = function(n) {
        return A2(fs, "click", wt(n));
    }, bs = A2(oe, A2(Uf, 2, "0"), Ir), ds = Mn, vs = F2(function(n, r) {
        return A3(Ti, A2(ds, n, r), !1, "");
    }), ls = vs, hs = A2(to, "font-size", "1rem"), ws = A2(to, "width", "1rem"), ps = A2(to, "width", "100%"), $s = F2(function(n, r) {
        var t;
        return A2(ro, h([
            Jc(h([
                eo,
                ao
            ]))
        ]), h([
            A2(ro, h([
                Jc(h([
                    hs
                ]))
            ]), h([
                A2(es, h([
                    Jc(h([
                        ps,
                        eo,
                        is
                    ])),
                    ss(r(n + 1)),
                    A2(ls, "touch-action", "manipulation")
                ]), h([
                    (t = h([
                        Go(h([
                            us,
                            ws
                        ]))
                    ]), A2(So, t, h([
                        A2(zo, h([
                            xo("M10.707 7.05L10 6.343 4.343 12l1.414 1.414L10 9.172l4.243 4.242L15.657 12z")
                        ]), d)
                    ])))
                ]))
            ])),
            A2(ro, d, h([
                Eo(bs(n))
            ])),
            A2(ro, h([
                Jc(h([
                    hs
                ]))
            ]), h([
                A2(es, h([
                    Jc(h([
                        ps,
                        eo,
                        is
                    ])),
                    ss(r(n - 1)),
                    A2(ls, "touch-action", "manipulation")
                ]), h([
                    as(h([
                        Go(h([
                            us,
                            ws
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), gs = function(n) {
        if (n.$) return A2(Tf, h([
            Jc(h([
                ts,
                Gf,
                Mf,
                Rf,
                Cf
            ]))
        ]), h([
            rs(n)
        ]));
        var r = Hu(n.a), t = r.a9, e = r.a1, a = r.a_;
        return A2(ro, h([
            Jc(h([
                ts,
                Gf,
                Mf,
                eo,
                Sf,
                Rf
            ]))
        ]), h([
            A2($s, a, A2(oe, zf, jf)),
            A2(ro, h([
                Jc(h([
                    Mf
                ]))
            ]), h([
                Eo(":")
            ])),
            A2($s, e, A2(oe, zf, Ff)),
            A2(ro, h([
                Jc(h([
                    Mf
                ]))
            ]), h([
                Eo(":")
            ])),
            A2($s, t, A2(oe, zf, Lf))
        ]));
    }, ms = A5(Po, "rgb", "107", "114", "128", Bo), ys = A5(Po, "rgb", "34", "197", "94", Bo), xs = F2(function(n, r) {
        var t = n.a4, e = n.a5, a = n.aG, u = n.a6;
        switch(r.$){
            case 0:
                return u;
            case 1:
            case 2:
            case 4:
                return a;
            case 3:
                return e;
            default:
                return t;
        }
    }), ks = A5(Po, "rgb", "239", "68", "68", Bo), _s = A2(to, "transition-duration", "500ms"), As = A2(to, "transition-timing-function", "cubic-bezier(0, 0, 0.2, 1)"), zs = A5(Po, "rgb", "209", "213", "219", Bo), js = so(h([
        A2(to, "margin-top", "0.5rem"),
        A2(to, "margin-bottom", "0.5rem")
    ])), Fs = E, Ls = function(n) {
        return A2(ls, "width", Fs(n) + "%");
    }, Ss = A2(to, "font-size", "1.125rem"), Gs = so(h([
        A2(to, "transition-property", "color, background-color, border-color, text-decoration-color, fill, stroke"),
        A2(to, "transition-timing-function", "cubic-bezier(0.4, 0, 0.2, 1)"),
        A2(to, "transition-duration", "150ms")
    ])), Rs = F3(function(n, r, t) {
        return A2(ro, h([
            Jc(h([
                ps,
                js,
                vo(zs),
                Ko,
                Jo(Wo),
                Ss,
                Rf
            ]))
        ]), h([
            A2(ro, A2(zr, Ls(t), b(n, h([
                Jc(h([
                    Gs,
                    _s,
                    As,
                    _f
                ]))
            ]))), r)
        ]));
    }), Ts = function(n) {
        var r = A2(xs, {
            a4: c("Finished", vo(ks)),
            a5: c("Paused", vo(ms)),
            aG: c("Go!", vo(ys)),
            a6: c("Ready", vo(ms))
        }, n), t = r.a;
        return A3(Rs, h([
            Jc(h([
                r.b
            ]))
        ]), h([
            Eo(t)
        ]), function(n) {
            return 5 === n.$ ? 100 : hi(ns(n)) / hi(ni(n)) * 100;
        }(n));
    }, Cs = A2(to, "cursor", "not-allowed"), Ms = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Ns = function(n) {
        return Ms(function(n) {
            return {
                $: 2,
                a: n
            };
        }(n));
    }, Es = Ns("disabled"), Os = uf("disabled"), Is = A2(to, "font-weight", "700"), Hs = A2(to, "margin", "0.5rem"), Zs = A2(to, "opacity", "0.75"), qs = A2(to, "border-radius", "0.25rem"), Ps = function(n) {
        var r = n.aF, t = n.au, e = r.$ ? Os(!0) : ss(r.a);
        return h([
            Jc(h([
                t,
                Jo(Wo),
                Is,
                Uo,
                Hs,
                qs,
                Es(h([
                    Zs,
                    Cs
                ]))
            ])),
            A2(ls, "touch-action", "manipulation"),
            e
        ]);
    }, Bs = A2(es, Ps({
        au: vo(ms),
        aF: Er
    }), h([
        Eo("Reset")
    ])), Ds = {
        $: 2
    }, Qs = Ns("hover"), Us = A5(Po, "rgb", "220", "38", "38", Bo), Xs = A2(es, A2(zr, Jc(h([
        Qs(h([
            vo(Us)
        ]))
    ])), Ps({
        au: vo(ms),
        aF: Nr(sa(Ds))
    })), h([
        Eo("Reset")
    ])), Vs = A2(es, A2(zr, Jc(h([
        Qs(h([
            vo(Us)
        ]))
    ])), Ps({
        au: vo(ks),
        aF: Nr(sa(Ds))
    })), h([
        Eo("Reset")
    ])), Ks = function(n) {
        switch(n.$){
            case 0:
                return Bs;
            case 5:
                return Vs;
            default:
                return Xs;
        }
    }, Js = A2(es, Ps({
        au: vo(ys),
        aF: Er
    }), h([
        Eo("Start")
    ])), Ys = A5(Po, "rgb", "22", "163", "74", Bo), Ws = A2(es, A2(zr, Jc(h([
        Qs(h([
            vo(Ys)
        ]))
    ])), Ps({
        au: vo(ys),
        aF: Nr(sa({
            $: 0
        }))
    })), h([
        Eo("Start")
    ])), nb = A5(Po, "rgb", "59", "130", "246", Bo), rb = A5(Po, "rgb", "37", "99", "235", Bo), tb = A2(es, A2(zr, Jc(h([
        Qs(h([
            vo(rb)
        ]))
    ])), Ps({
        au: vo(nb),
        aF: Nr(sa({
            $: 1
        }))
    })), h([
        Eo("Stop")
    ])), eb = function(n) {
        return function(n) {
            var r = Yf(!1);
            return A2(xs, f(r, {
                aG: !0
            }), n);
        }(n) ? tb : ui(ni(n)) ? Ws : Js;
    }, ab = A2(to, "border-width", "1px"), ub = A5(Po, "rgb", "191", "219", "254", Bo), ib = A5(Po, "rgb", "29", "78", "216", Bo), cb = A2(to, "font-weight", "600"), ob = A5(Po, "rgb", "0", "0", "0", {
        $: 0,
        a: "0"
    }), fb = F2(function(n, r) {
        return A2(mo, h([
            Mo(r),
            Jc(h([
                Qs(h([
                    vo(nb),
                    Jo(Wo)
                ])),
                vo(ob),
                Jo(ib),
                ho(ub),
                cb,
                Uo
            ]))
        ]), h([
            Eo(n)
        ]));
    }), sb = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), bb = sb(2)(h([
        A2(co, ":not([hidden]) ~ :not([hidden])", h([
            A2(to, "--tw-divide-y-reverse", "0"),
            A2(to, "border-top-width", "calc(1px * calc(1 - var(--tw-divide-y-reverse)))"),
            A2(to, "border-bottom-width", "calc(1px * var(--tw-divide-y-reverse))")
        ]))
    ])), db = A2(to, "grid-template-columns", "repeat(1, minmax(0, 1fr))"), vb = A2(to, "margin-top", "1rem"), lb = {
        bH: h([
            A2(yf, h([
                Jc(h([
                    wf
                ]))
            ]), h([
                A2(ro, h([
                    Jc(h([
                        hf,
                        xf,
                        kf,
                        eo,
                        ao
                    ]))
                ]), h([
                    A2(ro, h([
                        Jc(h([
                            Ko,
                            vb,
                            po,
                            db,
                            bb,
                            ab,
                            ho(nb),
                            qs
                        ]))
                    ]), h([
                        A2(fb, "Countdown", De(Er)),
                        A2(fb, "Restwatch", Ue),
                        A2(fb, "Stopwatch", Xe)
                    ]))
                ]))
            ]))
        ]),
        bZ: "Timers"
    }, hb = {
        bH: h([
            A2(yf, d, h([
                A2(go, d, h([
                    Eo("Not Found")
                ]))
            ]))
        ]),
        bZ: "Page Not Found"
    }, wb = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pb = A2(to, "transition-duration", "1000ms"), $b = F2(function(n, r) {
        var t = n.a4, e = n.G, a = n.aG, u = n.a6;
        switch(r.$){
            case 0:
                return u;
            case 1:
            case 2:
            case 5:
            case 6:
                return a;
            case 3:
            case 7:
            case 8:
                return e;
            default:
                return t;
        }
    }), gb = $b({
        a4: d,
        G: d,
        aG: h([
            Jo(ms)
        ]),
        a6: h([
            Jo(ms)
        ])
    }), mb = function(n) {
        return {
            a4: n,
            G: n,
            aG: n,
            a6: n
        };
    }, yb = (_a = mb(d), $b(f(_a, {
        G: h([
            Jo(ms)
        ])
    }))), xb = A2(to, "margin-left", "0.5rem"), kb = A2(to, "position", "relative"), _b = F2(function(n, r) {
        return n(r);
    }), Ab = function(n) {
        return _b(A2(oe, A2(oe, vi, at(n)), Kr));
    }, zb = F2(function(n, r) {
        return A2(Ab, li(n), r);
    }), jb = F2(function(n, r) {
        var t = n.a4, e = n.G, a = n.aG, u = n.a6, i = r.u, o = r._;
        switch(i.$){
            case 0:
                return u(c(be(0), be(0)));
            case 1:
                return a(c(be(0), be(0)));
            case 2:
            case 5:
            case 6:
                return a(function(n) {
                    return c(n, n);
                }(A2(zb, o, Vu(f = i.a))));
            case 3:
            case 7:
                return f = i.b, e(c(A2(zb, o, i.a), Vu(f)));
            case 8:
                var f = i.b;
                return e(c(A2(zb, o, i.a), Vu(f)));
            default:
                return t(c(A2(zb, o, i.a), be(0)));
        }
    }), Fb = function(n) {
        return n.b;
    }, Lb = function(n) {
        return A2(Of, h([
            Nf(Pf(n))
        ]), h([
            Eo(Kf(n))
        ]));
    }, Sb = (za = (Aa = mb(Lb)).G, ja = Aa.aG, Fa = Aa.a6, jb({
        a4: A2(oe, Aa.a4, Fb),
        G: A2(oe, za, Fb),
        aG: A2(oe, ja, Fb),
        a6: A2(oe, Fa, Fb)
    })), Gb = F2(function(n, r) {
        var t = n.a4, e = n.G, a = n.aG, u = n.a6, i = r.u;
        switch(i.$){
            case 0:
                return u(be(0));
            case 1:
                return a(be(0));
            case 2:
            case 5:
            case 6:
                return a(Vu(i.a));
            case 3:
            case 7:
            case 8:
                return e(i.a);
            default:
                return t(i.a);
        }
    }), Rb = Gb(mb(Lb)), Tb = A2(to, "text-align", "left"), Cb = function(n) {
        return Ir(n) + "%";
    }, Mb = function(n) {
        var r = n.a, e = n.b;
        return t(r, e) ? 100 : hi(e) / hi(r) * 100;
    }, Nb = jb({
        a4: function() {
            return 100;
        },
        G: Mb,
        aG: Mb,
        a6: Mb
    }), Eb = A5(Po, "rgb", "234", "88", "12", Bo), Ob = function(n) {
        var r = A2($b, {
            a4: c("Finished", vo(Us)),
            G: c("Rest...", vo(Eb)),
            aG: c("Go!", vo(Ys)),
            a6: c("Get Ready!", vo(ms))
        }, n.u), t = r.a;
        return A3(Rs, h([
            Jc(h([
                r.b
            ]))
        ]), h([
            Eo(t)
        ]), Nb(n));
    }, Ib = A2(es, Ps({
        au: vo(ms),
        aF: Er
    }), h([
        Eo("Reset")
    ])), Hb = {
        $: 3
    }, Zb = A2(es, A2(zr, Jc(h([
        Qs(h([
            vo(Us)
        ]))
    ])), Ps({
        au: vo(ms),
        aF: Nr(Ra(Hb))
    })), h([
        Eo("Reset")
    ])), qb = A2(es, A2(zr, Jc(h([
        Qs(h([
            vo(Us)
        ]))
    ])), Ps({
        au: vo(ks),
        aF: Nr(Ra(Hb))
    })), h([
        Eo("Reset")
    ])), Pb = function(n) {
        switch(n.$){
            case 0:
                return Ib;
            case 4:
                return qb;
            default:
                return Zb;
        }
    }, Bb = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Db = A2(to, "position", "absolute"), Qb = A5(Po, "rgb", "0", "0", "0", Bo), Ub = A5(Po, "rgb", "229", "231", "235", Bo), Xb = A5(Po, "rgb", "156", "163", "175", Bo), Vb = A5(Po, "rgb", "55", "65", "81", Bo), Kb = so(h([
        A2(to, "padding-top", "0.25rem"),
        A2(to, "padding-bottom", "0.25rem")
    ])), Jb = so(h([
        A2(to, "--tw-shadow", "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)"),
        A2(to, "--tw-shadow-colored", "0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color)"),
        A2(to, "box-shadow", "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)")
    ])), Yb = A2(to, "z-index", "10"), Wb = function(n) {
        var r = n._;
        return n.ak ? Eo("") : function(n) {
            return A2(ro, h([
                Jc(h([
                    ps,
                    Db,
                    Yb,
                    Af,
                    mf,
                    Jo(Qb),
                    vo(Xb),
                    ho(Vb),
                    ab,
                    bb,
                    Jb
                ]))
            ]), A2(It, function(r) {
                return t(r, n) ? A2(es, h([
                    Jc(h([
                        ps,
                        Kb,
                        vo(Qo),
                        Jo(Wo)
                    ]))
                ]), h([
                    Eo(Ir(r) + "%")
                ])) : A2(es, h([
                    Jc(h([
                        ps,
                        Kb,
                        vo(Wo),
                        Qs(h([
                            vo(Ub)
                        ]))
                    ])),
                    ss(Bb(r))
                ]), h([
                    Eo(Ir(r) + "%")
                ]));
            }, h([
                25,
                50,
                75,
                100,
                150,
                200
            ])));
        }(r);
    }, nd = A2(es, A2(zr, Jc(h([
        Qs(h([
            vo(rb)
        ]))
    ])), Ps({
        au: vo(nb),
        aF: Nr(Ra({
            $: 2
        }))
    })), h([
        Eo("Pause")
    ])), rd = A2(es, A2(zr, Jc(h([
        Qs(h([
            vo(Eb)
        ]))
    ])), Ps({
        au: vo(Qo),
        aF: Nr(Ra({
            $: 1
        }))
    })), h([
        Eo("Rest")
    ])), td = A2(es, A2(zr, Jc(h([
        Qs(h([
            vo(Ys)
        ]))
    ])), Ps({
        au: vo(ys),
        aF: Nr(Ra({
            $: 0
        }))
    })), h([
        Eo("Start")
    ])), ed = function(n) {
        switch(n.$){
            case 0:
            default:
                return td;
            case 1:
            case 2:
            case 5:
            case 6:
            case 7:
                return rd;
            case 3:
            case 8:
                return nd;
        }
    }, ad = function(n) {
        var r, t;
        return h([
            A2(yf, h([
                Jc(h([
                    wf,
                    hf,
                    xf,
                    kf,
                    eo,
                    ao
                ]))
            ]), h([
                A2(ro, h([
                    Jc(h([
                        vb,
                        eo,
                        ao
                    ]))
                ]), h([
                    A2(ro, h([
                        Jc(b(yb(n.u), h([
                            Gs,
                            pb,
                            As,
                            Mf
                        ])))
                    ]), h([
                        A2(Tf, h([
                            Jc(h([
                                Tb
                            ]))
                        ]), h([
                            Eo("Activity")
                        ])),
                        A2(Tf, h([
                            Jc(h([
                                ts,
                                mf,
                                Gf,
                                Ef
                            ]))
                        ]), h([
                            Rb(n)
                        ]))
                    ])),
                    A2(ro, h([
                        Jc(b(gb(n.u), h([
                            Gs,
                            pb,
                            As,
                            Mf,
                            kb
                        ])))
                    ]), h([
                        A2(es, h([
                            ss(wb((t = n.ak, t ? 0 : 1)))
                        ]), h([
                            A2(ro, h([
                                Jc(h([
                                    eo,
                                    No
                                ]))
                            ]), h([
                                A2(Tf, h([
                                    Jc(h([
                                        Tb
                                    ]))
                                ]), h([
                                    Eo("Rest (" + Cb(n._) + ")")
                                ])),
                                (r = h([
                                    Go(h([
                                        ws,
                                        us,
                                        xb
                                    ]))
                                ]), A2(So, r, h([
                                    A2(zo, h([
                                        xo("M3.94 6.5L2.22 3.64l1.42-1.42L6.5 3.94c.52-.3 1.1-.54 1.7-.7L9 0h2l.8 3.24c.6.16 1.18.4 1.7.7l2.86-1.72 1.42 1.42-1.72 2.86c.3.52.54 1.1.7 1.7L20 9v2l-3.24.8c-.16.6-.4 1.18-.7 1.7l1.72 2.86-1.42 1.42-2.86-1.72c-.52.3-1.1.54-1.7.7L11 20H9l-.8-3.24c-.6-.16-1.18-.4-1.7-.7l-2.86 1.72-1.42-1.42 1.72-2.86c-.3-.52-.54-1.1-.7-1.7L0 11V9l3.24-.8c.16-.6.4-1.18.7-1.7zM10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z")
                                    ]), d)
                                ])))
                            ])),
                            A2(Tf, h([
                                Jc(h([
                                    ts,
                                    mf,
                                    Gf
                                ]))
                            ]), h([
                                Sb(n)
                            ]))
                        ])),
                        Wb(n)
                    ]))
                ])),
                Ob(n)
            ])),
            A2(pf, h([
                Jc(h([
                    hf,
                    xf,
                    po,
                    gf,
                    $f,
                    Af,
                    mf,
                    _f
                ]))
            ]), h([
                ed(n.u),
                Pb(n.u)
            ]))
        ]);
    }, ud = A2(to, "position", "fixed"), id = A2(to, "inset", "0px"), cd = function(n) {
        var r;
        return r = function(n) {
            switch(n.$){
                case 0:
                case 1:
                    return be(0);
                case 2:
                    return Vu(n.a);
                default:
                    return n.a;
            }
        }(n), A2(Of, h([
            Nf(Pf(r)),
            Jc(h([
                Ef
            ]))
        ]), h([
            Eo(Kf(r))
        ]));
    }, od = A2(es, Ps({
        au: vo(ms),
        aF: Er
    }), h([
        Eo("Reset")
    ])), fd = A2(es, A2(zr, Jc(h([
        Qs(h([
            vo(Us)
        ]))
    ])), Ps({
        au: vo(ms),
        aF: Nr({
            $: 2
        })
    })), h([
        Eo("Reset")
    ])), sd = function(n) {
        return n.$ ? fd : od;
    }, bd = A2(es, A2(zr, Jc(h([
        Qs(h([
            vo(Ys)
        ]))
    ])), Ps({
        au: vo(ys),
        aF: Nr({
            $: 0
        })
    })), h([
        Eo("Start")
    ])), dd = A2(es, A2(zr, Jc(h([
        Qs(h([
            vo(rb)
        ]))
    ])), Ps({
        au: vo(nb),
        aF: Nr({
            $: 1
        })
    })), h([
        Eo("Stop")
    ])), vd = function(n) {
        return function(n) {
            switch(n.$){
                case 0:
                case 3:
                    return !1;
                default:
                    return !0;
            }
        }(n) ? dd : bd;
    }, ld = F3(function(n, r, t) {
        return {
            $: 2,
            a: n,
            b: r,
            c: t
        };
    }), hd = F4(function(n, r, t, e) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), wd = Tn, pd = Pn, $d = F2(function(n, r) {
        var t = r.b, e = r.c;
        return A3(Ti, A2(pd, n, r.a), t, e);
    }), gd = F2(function(n, r) {
        switch(r.$){
            case 0:
                var t = r.b, e = r.c;
                return A3(Yc, r.a, A2(It, $d(n), t), A2(It, gd(n), e));
            case 1:
                return t = r.c, e = r.d, A4(ko, r.a, r.b, A2(It, $d(n), t), A2(It, gd(n), e));
            case 2:
                return t = r.b, e = r.c, A3(ld, r.a, A2(It, $d(n), t), A2(It, function(r) {
                    return c(r.a, A2(gd, n, r.b));
                }, e));
            case 3:
                return t = r.c, e = r.d, A4(hd, r.a, r.b, A2(It, $d(n), t), A2(It, function(r) {
                    return c(r.a, A2(gd, n, r.b));
                }, e));
            default:
                return uo(A2(wd, n, r.a));
        }
    }), md = gd, yd = F3(function(n, r, t) {
        var e = A2(rf, n, t), a = e.bH, u = e.bZ;
        return {
            bH: A2(It, md(r), a),
            bZ: u
        };
    }), xd = function(n) {
        switch(n.$){
            case 0:
                return A2(rf, 0, tf);
            case 1:
                return A2(rf, 0, hb);
            case 2:
                return A2(rf, 1, lb);
            case 3:
                return A3(yd, 2, ne, function(n) {
                    var r;
                    return {
                        bH: A2(zr, bf, (r = n.b, h([
                            A2(yf, h([
                                Jc(h([
                                    wf
                                ]))
                            ]), h([
                                A2(ro, h([
                                    Jc(h([
                                        hf,
                                        xf,
                                        kf,
                                        eo,
                                        ao
                                    ]))
                                ]), h([
                                    gs(r),
                                    Ts(r)
                                ]))
                            ])),
                            A2(pf, h([
                                Jc(h([
                                    hf,
                                    xf,
                                    po,
                                    gf,
                                    $f,
                                    Af,
                                    mf,
                                    _f
                                ]))
                            ]), h([
                                eb(r),
                                Ks(r)
                            ]))
                        ]))),
                        bZ: "Countdown"
                    };
                }(n.a));
            case 4:
                return A3(yd, 3, re, function(n) {
                    var r, t = n.b;
                    return {
                        bH: A2(zr, bf, A2(zr, (r = t.ak, r ? Eo("") : A2(ro, h([
                            Jc(h([
                                Yb,
                                ud,
                                id
                            ])),
                            ss(wb(1))
                        ]), d)), ad(t))),
                        bZ: "Restwatch"
                    };
                }(n.a));
            default:
                return A3(yd, 4, te, function(n) {
                    var r;
                    return {
                        bH: (r = n.b, h([
                            A2(yf, h([
                                Jc(h([
                                    wf
                                ]))
                            ]), h([
                                A2(ro, h([
                                    Jc(h([
                                        hf,
                                        xf,
                                        kf,
                                        eo,
                                        ao
                                    ]))
                                ]), h([
                                    A2(ro, h([
                                        Jc(h([
                                            vb,
                                            eo,
                                            ao
                                        ]))
                                    ]), h([
                                        A2(Tf, h([
                                            Jc(h([
                                                Mf,
                                                ts,
                                                mf,
                                                Gf
                                            ]))
                                        ]), h([
                                            cd(r)
                                        ]))
                                    ]))
                                ]))
                            ])),
                            A2(pf, h([
                                Jc(h([
                                    hf,
                                    xf,
                                    po,
                                    gf,
                                    $f,
                                    Af,
                                    mf,
                                    _f
                                ]))
                            ]), h([
                                vd(r),
                                sd(r)
                            ]))
                        ])),
                        bZ: "Stopwatch"
                    };
                }(n.a));
        }
    }, kd = function(n) {
        var r = n.dO, t = n.dP, e = function() {
            e.a(r(gr()));
        };
        return wr({
            bT: function(n) {
                return e.a = n, xr.addEventListener("popstate", e), 0 > xr.navigator.userAgent.indexOf("Trident") || xr.addEventListener("hashchange", e), F2(function(r, e) {
                    if (!(e.ctrlKey || e.metaKey || e.shiftKey || e.button >= 1 || r.target || r.hasAttribute("download"))) {
                        e.preventDefault();
                        var a = r.href, u = gr(), i = Tt(a).a;
                        n(t(i && u.cL === i.cL && u.cq === i.cq && u.cI.a === i.cI.a ? function(n) {
                            return {
                                $: 0,
                                a: n
                            };
                        }(i) : function(n) {
                            return {
                                $: 1,
                                a: n
                            };
                        }(a)));
                    }
                });
            },
            dx: function(r) {
                return A3(n.dx, r, gr(), e);
            },
            d4: n.d4,
            d2: n.d2,
            d_: n.d_
        });
    }({
        dx: ca,
        dO: function(n) {
            return {
                $: 1,
                a: n
            };
        },
        dP: function(n) {
            return {
                $: 0,
                a: n
            };
        },
        d_: function(n) {
            switch(n.$){
                case 0:
                case 1:
                case 2:
                    return fa;
                case 3:
                    return A2(oa, ne, function(n) {
                        switch(n.b.$){
                            case 0:
                            case 3:
                            default:
                                return fa;
                            case 1:
                            case 2:
                            case 4:
                                return Ga(A2(oe, sa, ba));
                        }
                    }(n.a));
                case 4:
                    return A2(oa, re, function(n) {
                        switch(n.b.u.$){
                            case 1:
                            case 6:
                            case 8:
                            case 2:
                            case 3:
                                return Ga(A2(oe, Ra, Ta));
                            default:
                                return fa;
                        }
                    }(n.a));
                default:
                    return A2(oa, te, function(n) {
                        switch(n.b.$){
                            case 0:
                            case 3:
                                return fa;
                            default:
                                return Ga(Ca);
                        }
                    }(n.a));
            }
        },
        d2: Ri,
        d4: A2(Yt, xd, ku)
    });
    La = {
        Main: {
            init: kd(wt(0))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? g(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, La) : n.Elm = La;
}($64eaa142b8a11f76$exports);


const $72db1a55c3a1ac6d$var$checkElement = async (selector)=>{
    while(document.querySelector(selector) === null)await new Promise((resolve)=>requestAnimationFrame(resolve));
    return document.querySelector(selector);
};
var $72db1a55c3a1ac6d$var$app = (0, $64eaa142b8a11f76$exports.Elm).Main.init({
    flags: null
});
$72db1a55c3a1ac6d$var$app.ports.alarm.subscribe((cmd)=>{
    $72db1a55c3a1ac6d$var$checkElement("audio#alarm").then((audio)=>{
        switch(cmd){
            case "load":
                audio.load();
            case "pause":
            case "stop":
                audio.pause();
                break;
            case "play":
                audio.currentTime = 0;
                audio.play();
                break;
        }
    });
});


//# sourceMappingURL=repo.8b038c6d.js.map
